<template>
  <diV>
    <v-row>
      <v-col v-if="featureFlags.sog4117 && !isFixedWireless" cols="12" md="12" lg="12" class="pb-0">
        <v-radio-group
          row
          v-model="nbnOrder.nbnAssureRequired"
          :disabled="isOriginal"
          class="mt-0"
        >
          <label class="mr-2">NBN Assure</label>
          <v-radio label="Yes" value="Yes"></v-radio>
          <v-radio label="No" value="No"></v-radio>
        </v-radio-group>
      </v-col>
      <v-col
        v-if="featureFlags.sog4117 && !isFixedWireless && nbnOrder.nbnAssureRequired === 'Yes'"
        cols="6"
        md="6"
        lg="6"
        class="pb-0"
      >
        <ValidationProvider
          name="NBN Assure Options"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-select
            :items="nbnAssureOptions"
            label="NBN Assure Options"
            outlined
            placeholder=" "
            :clearable="!isOriginal"
            v-model="nbnOrder.nbnAssureOption"
            :error-messages="!isOriginal ? errors : ''"
            dense
            :readonly="isOriginal"
            :disabled="isPendingServiceability || isOriginal"
          ></v-select>
        </ValidationProvider>
      </v-col>

      <v-col
        v-if="featureFlags.sog4117 && !isFixedWireless && nbnOrder.nbnAssureRequired === 'Yes'"
        cols="12"
        md="12"
        lg="12"
        class="pb-0"
      >
        <v-radio-group
          row
          v-model="nbnOrder.simRequired"
          :disabled="isOriginal"
        >
          <label class="mr-2">SIM Required</label>
          <v-radio name="simRequired" label="Yes" value="Yes"></v-radio>
          <v-radio name="simRequired" label="No" value="No"></v-radio>
        </v-radio-group>
      </v-col>
      <v-col
        v-if="
          featureFlags.sog4117 &&
            !isFixedWireless &&
            nbnOrder.simRequired === 'Yes' &&
            nbnOrder.nbnAssureRequired === 'Yes'
        "
        cols="6"
        md="6"
        lg="6"
        class="pb-0"
      >
        <ValidationProvider
          name="SIM Delivery Address"
          :rules="'required|locationValidator'"
          v-slot="{ errors }"
        >
          <v-text-field
            v-model="nbnOrder.simAddress"
            label="SIM Delivery Address"
            placeholder=" "
            outlined
            dense
            :readonly="isOriginal"
            :error-messages="!isOriginal ? errors : ''"
            :disabled="isPendingServiceability"
          ></v-text-field>
        </ValidationProvider>
      </v-col>
      <v-col
        v-else-if="
          featureFlags.sog4117 &&
            !isFixedWireless &&
            nbnOrder.simRequired === 'No' &&
            nbnOrder.nbnAssureRequired === 'Yes'
        "
        cols="6"
        md="6"
        lg="6"
        class="pb-0"
      >
        <ValidationProvider name="USIM" :rules="'required'" v-slot="{ errors }">
          <v-text-field
            v-model="nbnOrder.usim"
            label="USIM"
            placeholder=" "
            outlined
            dense
            :readonly="isOriginal"
            :error-messages="!isOriginal ? errors : ''"
            :disabled="isPendingServiceability || isOriginal"
          ></v-text-field>
        </ValidationProvider>
      </v-col>

      <v-col v-if="featureFlags.sog4117" cols="12" md="12" lg="12" class="pb-0">
        <v-radio-group
          row
          v-model="nbnOrder.hardwareRequired"
          :disabled="isOriginal"
          class="mt-0"
        >
          <label class="mr-2">{{ hardwareLabel }}</label>
          <v-radio label="Yes" value="Yes"></v-radio>
          <v-radio label="No" value="No"></v-radio>
        </v-radio-group>
      </v-col>
      <v-col
        v-if="featureFlags.sog4117 && nbnOrder.hardwareRequired == 'Yes'"
        cols="6"
        md="6"
        lg="6"
        class="pb-0"
      >
        <ValidationProvider
          name="Hardware Options"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-select
            :items="
              isOriginal && isHistoricalOrder
                ? historicalHardwareOptions
                : hardwareOptions
            "
            :label="
              isOriginal && isHistoricalOrder
                ? 'Hardware Options'
                : 'Modem Options'
            "
            outlined
            placeholder=" "
            :clearable="!isOriginal"
            v-model="nbnOrder.hardwareOption"
            :error-messages="!isOriginal ? errors : ''"
            dense
            :readonly="isOriginal"
            :disabled="isPendingServiceability || isOriginal"
          ></v-select>
        </ValidationProvider>
      </v-col>
      <v-col cols="6" md="6" lg="6" class="pb-0"> </v-col>
      <v-col
        v-if="featureFlags.sog4117 && nbnOrder.hardwareRequired == 'Yes'"
        :cols="featureFlags.sog4117 ? '12' : '6'"
        :md="featureFlags.sog4117 ? '4' : '6'"
        :lg="featureFlags.sog4117 ? '4' : '6'"
        class="pb-0"
      >
        <ValidationProvider
          name="Hardware Delivery Address"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-text-field
            v-model="nbnOrder.hardwareAddress"
            label="Hardware Delivery Address"
            placeholder=" "
            outlined
            dense
            :readonly="isOriginal"
            :error-messages="!isOriginal ? errors : ''"
            :disabled="isPendingServiceability"
          ></v-text-field>
        </ValidationProvider>
      </v-col>

      <v-col
        cols="12"
        :md="4"
        class="pt-0 pb-1"
        v-if="
          featureFlags.sog4117 &&
            nbnOrder.hardwareRequired == 'Yes' &&
            !isOriginal
        "
      >
        <v-checkbox
          v-model="nbnOrder.sameHardwareContact"
          :disabled="isOriginal"
          label="Same Contact as Customer Contact"
        >
        </v-checkbox>
      </v-col>

      <v-col
        v-if="
          featureFlags.sog4117 &&
            nbnOrder.hardwareRequired == 'Yes' &&
            (!nbnOrder.sameHardwareContact || isOriginal)
        "
        cols="12"
        md="4"
        lg="4"
        class="pb-0"
      >
        <ValidationProvider
          name="Delivery Contact Name"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-text-field
            v-model="nbnOrder.hardwareContactName"
            label="Delivery Contact Name"
            placeholder=" "
            outlined
            dense
            :readonly="isOriginal"
            :error-messages="!isOriginal ? errors : ''"
            :disabled="isPendingServiceability"
          ></v-text-field>
        </ValidationProvider>
      </v-col>

      <v-col
        v-if="
          featureFlags.sog4117 &&
            nbnOrder.hardwareRequired == 'Yes' &&
            (!nbnOrder.sameHardwareContact || isOriginal)
        "
        cols="12"
        md="4"
        lg="4"
        class="pb-0"
      >
        <ValidationProvider
          name="Delivery Contact No."
          :rules="'required|custcontactnumber'"
          v-slot="{ errors }"
        >
          <v-text-field
            v-model="nbnOrder.hardwareContactNumber"
            label="Delivery Contact No."
            placeholder=" "
            outlined
            dense
            :readonly="isOriginal"
            :error-messages="!isOriginal ? errors : ''"
            :disabled="isPendingServiceability"
          ></v-text-field>
        </ValidationProvider>
      </v-col>

      <v-col
        cols="12"
        md="12"
        lg="12"
        class="py-0 mb-2"
        v-if="hasParties()"
      >
        <ValidationProvider
          name="End User Type"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-radio-group
            row
            v-model="nbnOrder.endUserType"
            :disabled="isPendingServiceability"
            class="mt-0"
            hide-details
          >
            <label class="mr-2">End User Type</label>
            <v-radio label="Business" value="Business" hide-details></v-radio>
            <v-radio
              label="Residential"
              value="Residential"
              hide-details
            ></v-radio>
          </v-radio-group>
          <span v-if="!nbnOrder.endUserType" class="error-message"
            >End User Type is required</span
          >
        </ValidationProvider>
      </v-col>

      <v-col cols="12" :md="6" class="pt-0 pb-1" v-if="isBusinessOrder">
        <ValidationProvider
          name="Organisation Party ID"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-combobox
            v-model="nbnOrder.partyId"
            :items="filteredParties"
            label="Organisation Party ID"
            outlined
            placeholder=" "
            :clearable="!isOriginal"
            :error-messages="!isOriginal ? errors : ''"
            dense
            :readonly="isOriginal"
            @update:modelValue="emitData('Party')"
            :disabled="isPendingServiceability"
          ></v-combobox>
        </ValidationProvider>
      </v-col>
      <v-col v-if="featureFlags.sog4117" cols="12" md="12" lg="12" class="py-0">
        <v-radio-group
          row
          v-model="nbnOrder.connectionDateRequire"
          :disabled="
            isOriginal ||
              nbnOrder.orderType == ''
          "
          persistent-hint
          hint="Note: This is not the activation date"
          class="mt-0 red-hint-radio"
        >
          <label class="mr-2">Order Submission Date/Time</label>
          <v-radio label="ASAP" value="No"></v-radio>
          <v-radio label="Select Date/Time" value="Yes" :disabled="nbnOrder.orderType.toLowerCase() == 'transfer'"></v-radio>
          <v-radio label="Held" value="Held"></v-radio>
        </v-radio-group>
      </v-col>

      <v-col
        v-if="
          featureFlags.sog4117 &&
            nbnOrder.connectionDateRequire == 'Yes' &&
            !isOriginal &&
            nbnOrder.orderType.toLowerCase() != 'transfer'
        "
        cols="12"
        :md="'6'"
        class="pt-0 pb-1"
      >
        <ValidationProvider
          name="Slot Date Time"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <date-picker
            v-model="nbnOrder.scheduledDateTime"
            :disabled-date="notBeforeToday"
            value-type="date"
            type="datetime"
            placeholder="Select Submit Date/Time"
          ></date-picker>
        </ValidationProvider>
      </v-col>
      <v-col
        v-else-if="
          featureFlags.sog4117 &&
            nbnOrder.connectionDateRequire == 'Yes' &&
            isOriginal
        "
        cols="6"
        md="6"
        lg="6"
        class="pb-0"
      >
        <ValidationProvider
          name="Scheduled Date Time"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-text-field
            v-model="nbnOrder.scheduledDateTimeString"
            label="Scheduled Date Time"
            placeholder=" "
            outlined
            dense
            :readonly="isOriginal"
            :error-messages="!isOriginal ? errors : ''"
            :disabled="isPendingServiceability"
          ></v-text-field>
        </ValidationProvider>
      </v-col>
    </v-row>
    <v-divider v-if="featureFlags.sog4117" class="my-4"></v-divider>

    <v-row>
      <v-col
        v-show="
          !isOriginal &&
            nbnOrder.orderType &&
            nbnOrder.orderType.toLowerCase() === 'transfer'
        "
      >
        <p class="red--text caption mb-0">
          *Transfer order will be submitted immediately to the carrier (no
          schedule possible).
        </p>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" lg="3" md="3" class="pb-2 pt-2" v-if="showCheckbox">
        <v-checkbox
          v-model="nbnOrder.isFibreConnect"
          label="Fibre Upgrade Order"
          :readonly="isOriginal"
          @change="emitData('Fibre Upgrade')"
        ></v-checkbox>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" :md="'6'" class="pt-0 pb-1">
        <ValidationProvider
          name="Order Type"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-select
            v-model="nbnOrder.orderType"
            :items="orderTypeFilterNew"
            label="Order Type"
            outlined
            placeholder=" "
            :clearable="!isOriginal"
            :error-messages="!isOriginal ? errors : ''"
            dense
            :readonly="isOriginal"
            @change="emitData('Order Type')"
            :disabled="isPendingServiceability"
          ></v-select>
        </ValidationProvider>
      </v-col>

      <v-col
        cols="12"
        :md="'6'"
        class="pt-0 pb-1"
        v-if="
          isTransfer &&
            (featureFlags.sog6974
              ? showConnectOutstandingFeature
              : isInternalWholesaler)
        "
      >
        <v-checkbox
          class="mt-0"
          v-model="nbnOrder.isConnectOutstanding"
          :disabled="isOriginal"
          label="Connect Outstanding"
        >
        </v-checkbox>
      </v-col>

      <v-col cols="12" :md="'6'" class="pt-0 pb-1" v-if="!isDisconnect">
        <ValidationProvider
          name="Product Type"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-select
            :items="productType"
            label="Product Type"
            outlined
            placeholder=" "
            :clearable="!isReadonly && !isOriginal"
            v-model="nbnOrder.productType"
            :error-messages="!isOriginal ? errors : ''"
            dense
            :readonly="isReadonly || isOriginal"
            @change="emitData()"
            :disabled="isPendingServiceability"
          ></v-select>
        </ValidationProvider>
      </v-col>

      <v-col
        cols="12"
        :md="6"
        class="pt-0 pb-1"
        v-if="isOriginal || (!impersonating && isAdmin && isOriginal)"
      >
        <ValidationProvider
          name="Customer Ref."
          :rules="
            !isOriginal && !impersonating
              ? 'custRef|isFirstCharValid|custRefLength'
              : ''
          "
          v-slot="{ errors }"
        >
          <v-text-field
            v-model="nbnOrder.customerRef"
            label="Customer Ref."
            placeholder=" "
            :error-messages="
              isCustRefDuplicate
                ? `${nbnOrder.customerRef} already exist`
                : errors
            "
            outlined
            dense
            :readonly="isOriginal"
            @input="checkValue('custRef')"
            :disabled="isPendingServiceability"
          ></v-text-field>
        </ValidationProvider>
      </v-col>

      <v-col cols="12" :md="6" class="pt-0 pb-1" v-if="showAuthReference">
        <ValidationProvider
          name="Customer Auth Ref."
          :rules="
            !isDisconnect
              ? 'required|custRef|isFirstCharValid|custRefLength'
              : ''
          "
          v-slot="{ errors }"
        >
          <v-text-field
            v-model="nbnOrder.customerAuthRef"
            label="Customer Auth Ref."
            placeholder=" "
            :error-messages="
              isAuthRefDuplicate
                ? `${nbnOrder.customerAuthRef} already exist`
                : errors
            "
            outlined
            dense
            :readonly="isOriginal"
            @input="checkValue('authRef')"
            :disabled="isPendingServiceability"
          ></v-text-field>
        </ValidationProvider>
      </v-col>

      <v-col cols="12" :md="6" class="pt-0 pb-1" v-if="!isDisconnect">
        <ValidationProvider
          name="Customer Firstname"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-text-field
            v-model="nbnOrder.customerFirstname"
            label="Customer Firstname"
            placeholder=" "
            outlined
            dense
            :readonly="isOriginal"
            :error-messages="!isOriginal ? errors : ''"
            :disabled="isPendingServiceability"
          ></v-text-field>
        </ValidationProvider>
      </v-col>

      <v-col cols="12" :md="6" class="pt-0 pb-1" v-if="!isDisconnect">
        <ValidationProvider
          name="Customer Surname"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-text-field
            v-model="nbnOrder.customerSurname"
            label="Customer Surname"
            placeholder=" "
            outlined
            dense
            :readonly="isOriginal"
            :error-messages="errors"
            :disabled="isPendingServiceability"
          ></v-text-field>
        </ValidationProvider>
      </v-col>

      <v-col cols="12" :md="6" class="pt-0 pb-1" v-if="!isDisconnect">
        <ValidationProvider
          name="Customer Email"
          :rules="'required|email'"
          v-slot="{ errors }"
        >
          <v-text-field
            v-model="nbnOrder.customerContactEmail"
            label="Customer Email"
            placeholder=" "
            outlined
            dense
            :readonly="isOriginal"
            :error-messages="!isOriginal ? errors : ''"
            :disabled="isPendingServiceability"
          ></v-text-field>
        </ValidationProvider>
      </v-col>

      <v-col cols="12" :md="6" class="pt-0 pb-1" v-if="!isDisconnect">
        <ValidationProvider
          name="Customer Contact No."
          :rules="'required|custcontactnumber'"
          v-slot="{ errors }"
        >
          <v-text-field
            v-model="nbnOrder.customerContactNumber"
            label="Customer Contact No."
            placeholder=" "
            outlined
            dense
            :readonly="isOriginal"
            :error-messages="!isOriginal ? errors : ''"
            :disabled="isPendingServiceability"
          ></v-text-field>
        </ValidationProvider>
      </v-col>

      <v-col cols="12" :md="6" class="pt-0 pb-1" v-if="requireProductTemplate">
        <ValidationProvider
          name="Product Template"
          :rules="requireProductTemplate ? 'required' : ''"
          v-slot="{ errors }"
        >
          <v-select
            :items="productTemplates"
            label="Product Template"
            name="Product Template"
            outlined
            placeholder="Please select Product Template"
            :clearable="!isOriginal && productTemplates.length > 1"
            v-model="nbnOrder.productTemplate"
            :error-messages="
              requireProductTemplate && !isOriginal ? errors : ''
            "
            dense
            :readonly="isOriginal"
            @change="emitData()"
          ></v-select>
        </ValidationProvider>
      </v-col>
      <v-col cols="12" :md="6" class="pt-0 pb-1" v-if="requireVlanTag">
        <ValidationProvider
          name="Tag Vlan"
          :rules="'required|vlanValue:2,4004'"
          v-slot="{ errors }"
        >
          <v-text-field
            label="Tag Vlan(Between 2 and 4004)"
            name="Tag Vlan"
            outlined
            placeholder="Please input Tag Vlan"
            :clearable="!isOriginal"
            v-model="nbnOrder.tagVlan"
            :error-messages="
              requireVlanTag && !isOriginal && errors ? errors : ''
            "
            dense
            :readonly="isOriginal"
            @change="emitData()"
          ></v-text-field>
        </ValidationProvider>
      </v-col>

      <v-col
        cols="12"
        :md="6"
        class="pt-0 pb-1"
        v-if="(!isDisconnect && !isNCAS) || nbnOrder.isFibreConnect"
      >
        <ValidationProvider
          name="NTD ID"
          :rules="isNtdRequired ? 'required' : ''"
          v-slot="{ errors }"
        >
          <v-select
            :items="ntdOptions"
            label="NTD ID"
            name="NTD ID"
            outlined
            placeholder="Please select NTD ID"
            :clearable="!isOriginal && ntdOptions.length > 1"
            v-model="nbnOrder.ntdId"
            :error-messages="isNtdRequired && !isOriginal ? errors : ''"
            dense
            :readonly="isOriginal"
            @change="
              if (!isFixedWireless) resetNtdModification();
              emitData();
            "
            :disabled="isPendingServiceability"
          ></v-select>
        </ValidationProvider>
      </v-col>

      <v-col
        cols="12"
        :md="6"
        class="pt-0 pb-1"
        v-if="showNtdModifications"
      >
        <ValidationProvider
          name="NTD Modifications"
          :rules="isNtdModificationsRequired ? 'required' : ''"
          v-slot="{ errors }"
        >
          <v-select
            :items="ntdModificationOptions"
            label="NTD Modifications"
            name="NTD Modifications"
            outlined
            placeholder="Please select NTD Modifications"
            :clearable="!isOriginal && ntdModificationOptions.length > 1"
            v-model="nbnOrder.ntdModifications"
            :error-messages="
              isNtdModificationsRequired && !isOriginal ? errors : ''
            "
            dense
            :readonly="isOriginal || isFixedWireless"
            @change="emitData('NTD Modifications')"
            :disabled="isPendingServiceability"
            :persistent-hint="isTransferOrder"
            :hint="transferNtdHint"
          ></v-select>
          <span
            v-if="showNtdWarning"
            class="pl-3 mb-3 text-caption red--text font-weight-bold"
            >*Requesting a New NTD may incur additional charges</span>
        </ValidationProvider>
      </v-col>

      <v-col
        cols="12"
        :md="6"
        class="pt-0 pb-1"
        v-if="(!isDisconnect && !isNCAS) || nbnOrder.isFibreConnect"
      >
        <ValidationProvider
          name="NTD Type"
          :rules="isNtdTypeRequired ? 'required' : ''"
          v-slot="{ errors }"
        >
          <v-select
            :items="ntdTypeOptions"
            label="NTD Type"
            name="NTD Type"
            outlined
            placeholder="Please select NTD Type"
            :clearable="!isOriginal && ntdTypeOptions.length > 1"
            v-model="nbnOrder.ntdType"
            :error-messages="isNtdTypeRequired && !isOriginal ? errors : ''"
            dense
            :readonly="isOriginal || isFixedWireless"
            @change="emitData()"
            :disabled="isPendingServiceability"
          ></v-select>
          <span
            v-if="nbnOrder.ntdId !== 'NTD Installation Required' && !isOriginal"
            style="padding-left:12px; margin-bottom: 12px; font-size:12px"
            >Previous NTD Type: {{ getCurrentNtdType }}</span
          >
          <span
            style="padding-left:12px; color:#f44336; font-size:12px"
            v-if="nbnOrder.ntdType === '4_PORT'"
            >*4_PORT will incur additional charges (unless lack of free port)</span
          >
        </ValidationProvider>
      </v-col>

      <v-col
        cols="12"
        :md="6"
        class="pt-0 pb-1"
        v-if="featureFlags.sog6146 && isTransfer && !connectOutstanding"
      >
        <ValidationProvider
          name="Service ID to Transfer"
          :rules="isTransfer ? 'required|avcFormat' : ''"
          v-slot="{ errors }"
        >
          <v-text-field
            v-if="featureFlags.sog6788"
            v-model="nbnOrder.serviceId"
            label="Service ID to Transfer"
            name="Service ID to Transfer"
            placeholder=""
            outlined
            dense
            @change="emitData()"
            :readonly="isOriginal"
            :error-messages="errors"
          ></v-text-field>
          <v-text-field
            v-else
            v-model="nbnOrder.avcId"
            label="Service ID to Transfer"
            name="Service ID to Transfer"
            placeholder=""
            outlined
            dense
            @change="emitData()"
            :readonly="isOriginal"
            :error-messages="errors"
          ></v-text-field>
        </ValidationProvider>
      </v-col>

      <v-col
        cols="12"
        :md="6"
        class="pt-0 pb-1"
        v-if="!isDisconnect && isNCAS && !nbnOrder.isFibreConnect"
      >
        <ValidationProvider
          name="CPI ID"
          :rules="isCpiRequired ? 'required' : ''"
          v-slot="{ errors }"
        >
          <v-select
            :items="cpiOptions"
            label="CPI ID"
            name="CPI ID"
            outlined
            placeholder="Please select CPI ID"
            :clearable="!isOriginal && cpiOptions.length > 1"
            v-model="nbnOrder.cpiId"
            :error-messages="isCpiRequired && !isOriginal ? errors : ''"
            dense
            :readonly="isOriginal"
            @change="emitData()"
            :disabled="
              isPendingServiceability ||
                (!hasActiveServices && nbnOrder.orderType == 'Transfer')
            "
            :hide-details="!hasActiveServices"
          ></v-select>
          <p
            v-if="
              !hasActiveServices &&
                nbnOrder.orderType == 'Transfer' &&
                !isOriginal
            "
            class="red--text caption"
          >
            *No active service to transfer
          </p>
        </ValidationProvider>
      </v-col>
      <v-col
        cols="12"
        :md="6"
        class="pt-0 pb-1"
        v-if="showReplaceNTD"
      >
        <v-checkbox
          v-model="nbnOrder.replaceNtd"
          :disabled="isOriginal"
          label="Replace NTD"
        >
        </v-checkbox>
      </v-col>
      <v-col cols="12" :md="'6'" class="pt-0 pb-1" v-if="isTransition">
        <ValidationProvider
          name="FNN or ULL ID"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-text-field
            v-model="nbnOrder.potsInterconnect"
            label="FNN or ULL ID"
            placeholder=" "
            outlined
            dense
            :readonly="isOriginal"
            :error-messages="!isOriginal ? errors : ''"
            :disabled="isPendingServiceability"
          ></v-text-field>
        </ValidationProvider>
      </v-col>

      <v-col
        cols="12"
        :md="'6'"
        class="pt-0 pb-1"
        v-if="needRemoveAppointmentDetail"
      >
        <ValidationProvider
          name="Installation Workforce"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-select
            :items="
              featureFlags.sog7142 && isOriginal
                ? workforceOptions
                : installationWorkforces
            "
            label="Installation Workforce"
            outlined
            placeholder=" "
            :clearable="!isOriginal"
            v-model="nbnOrder.installationWorkforce"
            :error-messages="!isOriginal ? errors : ''"
            dense
            :readonly="isOriginal"
            @change="onUpdateWorkforce()"
          ></v-select>
        </ValidationProvider>
      </v-col>

      <v-col cols="12" :md="'6'" class="pt-0 pb-1" v-if="isHfcRspInstall">
        <ValidationProvider
          name="MAC Address"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-text-field
            v-model="nbnOrder.macAddress"
            label="MAC Address"
            placeholder="Use the following format:88:1F:A2:26:15:F1"
            outlined
            dense
            :readonly="isOriginal"
            :error-messages="!isOriginal ? errors : ''"
            :disabled="isPendingServiceability"
          ></v-text-field>
        </ValidationProvider>
      </v-col>

      <v-col cols="12" :md="'6'" class="pt-0 pb-1" v-if="isHfcRspInstall">
        <ValidationProvider
          name="Serial Number"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-text-field
            v-model="nbnOrder.serialNumber"
            label="Serial Number"
            placeholder=" "
            outlined
            dense
            :readonly="isOriginal"
            :error-messages="!isOriginal ? errors : ''"
            :disabled="isPendingServiceability"
          ></v-text-field>
        </ValidationProvider>
      </v-col>

      <v-col
        v-if="
          (featureFlags.sog6522
            ? isAppointmentMandatoryNew
            : isAppointmentMandatory) && !isOriginal
        "
        cols="12"
        md="12"
        lg="12"
        class="pb-0"
      >
        <p v-show="!hasFreeNtd" class="red--text caption">
          *All UNI-D ports are used (the NTD is full). Appointment is required
          to order a new NTD.
        </p>

        <p
          v-show="showAppointmentNote"
          class="red--text caption font-weight-bold"
        >
          Appointment option MUST be selected
        </p>
        <ValidationProvider
          name="Require an Appointment for Activation"
          :rules="showAppointmentNote ? 'appointmentValidation' : ''"
          v-slot="{ errors }"
        >
          <v-radio-group
            v-if="showAppointmentNote"
            row
            v-model="checkType"
            :disabled="isOriginal || !hasFreeNtd || isPendingServiceability"
            :error-messages="errors"
          >
            <label class="mr-2">Require an Appointment for Activation?</label>
            <v-radio
              v-for="(item, index) in featureFlags.sog6522
                ? getLabelsNew
                : getLabels"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></v-radio>
          </v-radio-group>
        </ValidationProvider>
      </v-col>
      <v-col
        v-if="isAppointmentMandatory && isOriginal"
        cols="12"
        :md="6"
        class="pt-0 pb-1"
      >
        <ValidationProvider
          name="Appointment ID"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-text-field
            v-model="nbnOrder.appointmentId"
            label="Appointment ID"
            placeholder=" "
            outlined
            dense
            :readonly="isOriginal"
            :error-messages="!isOriginal ? errors : ''"
            :disabled="isPendingServiceability"
          ></v-text-field>
        </ValidationProvider>
      </v-col>

      <!-- start of new 2164 -->

      <v-col
        v-if="isLayer3 && featureFlags.sog5822"
        cols="12"
        md="6"
        class="pt-0 pb-1"
        style="margin-top: -15px"
      >
        <ValidationProvider
          name="Network Protocol"
          :rules="isLayer3 ? 'required' : ''"
          v-slot="{ errors }"
        >
          <div style="display: inline-block; font-size: 16px" class="mr-7">
            Network Protocol
          </div>
          <v-radio-group
            v-model="nbnOrder.isIpoe"
            row
            style="display: inline-block"
            :error-messages="errors"
            :readonly="isOriginal"
            @change="emitData()"
          >
            <v-radio label="IPoE" :value="true" :disabled="!featureFlags.sog5822"></v-radio>
            <v-radio label="PPPoE" :value="false"></v-radio>
          </v-radio-group>
        </ValidationProvider>
      </v-col>

      <v-col
        v-if="
          (showNewRadiusFields || showExistingRadiusFields) && showIPoEFeature
        "
        cols="12"
        md="12"
        lg="12"
        class="pb-0"
      >
        <v-radio-group row v-model="vispRequired" :disabled="isOriginal">
          <label class="mr-2">New Auth Credentials Required?</label>
          <v-radio label="Yes" :value="true"></v-radio>
          <v-radio label="No" :value="false"></v-radio>
          <p class="red--text caption">
            By clicking this 'No' option, we acknowledged a service already
            exist in VISP
          </p>
        </v-radio-group>
      </v-col>

      <v-col
        v-if="
          (showNewRadiusFields || showExistingRadiusFields) && showIPoEFeature
        "
        cols="12"
        md="12"
        lg="12"
      >
        <b
          ><p class="red--text bold">
            Radius Username and Radius Password are required.
          </p></b
        >
      </v-col>

      <v-col
        v-if="showNewRadiusFields && showIPoEFeature"
        cols="12"
        :md="'6'"
        class="pt-0 pb-1"
      >
        <ValidationProvider
          name="Radius Username"
          :rules="
            showNewRadiusFields ? 'required|noSpecialChars|radiusUsername' : ''
          "
          v-slot="{ errors }"
        >
          <v-text-field
            v-model="nbnOrder.radiusUsername"
            label="Radius Username"
            placeholder=" "
            autocomplete="new"
            @keyup="emitData('Radius Username')"
            outlined
            :error="enableUsernameError"
            :error-messages="
              isRadiusUsernameExisting
                ? `${nbnOrder.radiusUsername} already exist`
                : errors
            "
            dense
            :readonly="isOriginal"
            :disabled="isPendingServiceability || isOriginal"
          ></v-text-field>
        </ValidationProvider>
      </v-col>

      <v-col
        v-if="showNewRadiusFields && showIPoEFeature"
        cols="12"
        :md="'6'"
        class="pt-0 pb-1"
      >
        <ValidationProvider
          name="Radius Password"
          :rules="showNewRadiusFields ? 'required|min:4' : ''"
          v-slot="{ errors }"
        >
          <v-text-field
            v-model="nbnOrder.radiusPassword"
            label="Radius Password"
            placeholder=" "
            autocomplete="new"
            @blur="emitData()"
            :error="enablePasswordError"
            :error-messages="showNewRadiusFields ? errors : ''"
            outlined
            dense
            :readonly="isOriginal"
            :disabled="isPendingServiceability || isOriginal"
          ></v-text-field>
        </ValidationProvider>
      </v-col>

      <v-col
        v-if="showExistingRadiusFields && showIPoEFeature"
        cols="12"
        md="12"
        lg="12"
        class="pb-0"
      >
        <p class="red--text caption">
          Please Confirm existing details below:
        </p>
      </v-col>

      <v-col
        v-show="showExistingRadiusFields && showIPoEFeature"
        cols="12"
        :md="'6'"
        class="pt-0 pb-1"
      >
        <ValidationProvider
          name="Existing Radius Username"
          :rules="
            showExistingRadiusFields
              ? 'required|noSpecialChars|radiusUsername'
              : ''
          "
          v-slot="{ errors }"
        >
          <v-autocomplete
            :items="radiusUserNameResults"
            v-model="nbnOrder.existingRadiusUsername"
            label="Radius Username"
            placeholder=" "
            autocomplete="new"
            :search-input.sync="searchRadius"
            @change="emitData('Existing Radius Username')"
            :error-messages="showExistingRadiusFields ? errors : ''"
            outlined
            dense
            :readonly="isOriginal"
            :disabled="isPendingServiceability || isOriginal"
          ></v-autocomplete>
        </ValidationProvider>
      </v-col>

      <v-col
        v-if="showExistingRadiusFields && showIPoEFeature"
        cols="12"
        :md="'6'"
        class="pt-0 pb-1"
      >
        <ValidationProvider
          name="Existing Radius Password"
          :rules="showExistingRadiusFields ? 'required|min:4' : ''"
          v-slot="{ errors }"
        >
          <v-text-field
            v-model="nbnOrder.existingRadiusPassword"
            label="Radius Password"
            placeholder=" "
            autocomplete="new"
            @blur="emitData()"
            :error-messages="showExistingRadiusFields ? errors : ''"
            outlined
            dense
            :readonly="isOriginal"
            :disabled="isPendingServiceability || isOriginal"
          ></v-text-field>
        </ValidationProvider>
      </v-col>

      <v-col
        v-if="
          featureFlags.sog3890 && (showNewRadiusFields || hasVispCredentials)
        "
        cols="12"
        md="6"
        class="pt-0 pb-1"
        style="margin-top: -15px"
      >
        <ValidationProvider
          name="Static IP"
          :rules="isLayer3 ? 'required' : ''"
          v-slot="{ errors }"
        >
          <div style="display: inline-block; font-size: 16px" class="mr-7">
            Static IP
          </div>
          <v-radio-group
            v-model="nbnOrder.staticIP"
            row
            style="display: inline-block"
            :error-messages="errors"
            :readonly="isOriginal"
            @change="emitData()"
          >
            <v-radio label="Yes" :value="true"></v-radio>
            <v-radio label="No" :value="false"></v-radio>
          </v-radio-group>
        </ValidationProvider>
      </v-col>

      <v-col
        v-if="
          featureFlags.sog5666 &&
            (showNewRadiusFields || hasVispCredentials) &&
            nbnOrder.staticIP &&
            !isOriginal
        "
        cols="12"
        md="6"
        class="pt-0 pb-1"
        style="margin-top: -15px"
      >
        <ValidationProvider
          name="Static Ip Options"
          :rules="isLayer3 ? 'required' : ''"
          v-slot="{ errors }"
        >
          <v-radio-group
            v-model="nbnOrder.ipRange"
            row
            style="display: inline-block"
            :error-messages="errors"
            :readonly="isOriginal"
            @change="emitData()"
          >
            <v-radio label="Single Static Ip" :value="'0'"></v-radio>
            <v-radio
              v-if="!nbnOrder.isIpoe"
              label="/29 Ip Range"
              :value="'29'"
            ></v-radio>
            <v-radio
              v-if="!nbnOrder.isIpoe"
              label="/30 Ip Range"
              :value="'30'"
            ></v-radio>
          </v-radio-group>
        </ValidationProvider>
      </v-col>

      <v-col
        v-if="
          featureFlags.sog5666 &&
            (showNewRadiusFields || hasVispCredentials) &&
            nbnOrder.staticIP &&
            isOriginal
        "
        cols="12"
        :md="'6'"
        class="pt-0 pb-1"
      >
        <ValidationProvider name="Static Ip Address" v-slot="{ errors }">
          <v-text-field
            v-model="staticIpAddress"
            label="Static Ip Address"
            placeholder=" "
            outlined
            dense
            :readonly="isOriginal"
          ></v-text-field>
        </ValidationProvider>
      </v-col>
      <!-- end of new SOG3890 -->
      <v-col cols="12" class="pt-0 pb-1" v-if="isOriginal ? hasTechnicalContact : isFieldRequired">
        <nbn-technical-details
          ref="technicalDetailsRef"
          :fieldRequired="isFieldRequired"
          @updateContact="updateContact"
        ></nbn-technical-details>
      </v-col>

      <v-row class="mb-4" v-if="checkType == 'Customize'">
        <v-col
          cols="12"
          md="8"
          lg="9"
          class="pt-0 pb-0"
          :class="$vuetify.breakpoint.xs ? 'pr-3' : 'pr-0'"
        >
          <v-btn
            class="primary"
            @click="reserveAppointment({})"
            :style="$vuetify.breakpoint.xs ? 'width: 100%' : ''"
            :class="$vuetify.breakpoint.xs ? 'mt-4' : 'mt-6'"
            >Reserve an Appointment</v-btn
          >
          &nbsp;
        </v-col>
      </v-row>

      <v-col cols="12" :md="6" class="pt-0 pb-1" v-if="isDisconnect">
        <ValidationProvider name="Product Id" v-slot="{ errors }">
          <v-text-field
            v-model="nbnOrder.productId"
            label="Product Id"
            placeholder=" "
            outlined
            dense
            :readonly="isOriginal"
            :error-messages="!isOriginal ? errors : ''"
            :disabled="isPendingServiceability"
          ></v-text-field>
        </ValidationProvider>
      </v-col>
    </v-row>
    <reserve-nbn-appointment
      ref="reserveAppointment"
      :showNewAppointment="showNewAppointment"
      :businessOptionEnabled="businessOptionEnabled"
      @close="closeNewAppointment"
    ></reserve-nbn-appointment>
  </diV>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { DEFAULT_VONEX_ACCOUNT_NUMBER } from "../../constants";
import { NFASBandwidthProfile } from "../../constants";
import { BANDWIDTH_PROFILES } from "../../constants/nbn-edit-form-constants";
import {
  NBN_ASSURE_OPTIONS,
  NBN_ORDER_TYPES,
  SERVICE_CLASS_REQUIRED_APPOINTMENT,
  getProductTemplates,
  getNtdModificationOptions,
  getNtdTypeOptions,
  CONNECTION_DATE_REQUIRED_OPTIONS,
  SPECIAL_NTD_IDS,
  isRealNtdId,
  isSpecialNtdId,
  isV3SinglePortNtd,
  getConnectNtdIdOptionsFromResources,
  resolveOnSiteNtdId,
  includeCurrentSelectValue,
  NTD_MODIFICATION_OPTIONS,
  NTD_TYPE_FIXED_WIRELESS,
  inferFixedWirelessNtdVersion,
  getForcedFixedWirelessNtdModification,
  doesFwSpeedExceedNtd,
  resolveProductTemplateForType
} from "../../constants/nbn-order-item-constants";
export default {
  name: "nbnOrderItem",
  components: { DatePicker },
  props: {
    isNewOrder: { type: Boolean },
    newOrder: { type: Object },
    wholesalerAccount: { type: Number },
    ServiceClass: { type: String },
    showNewNbnOrder: { type: Boolean, required: true },
    showConnectOutstandingFeature: { type: Boolean },
    filteredParties: { type: Array},
    endUserType: { type: Boolean },
  },
  data: () => ({
    showNewAppointment: false,
    showQueryAppointment: false,
    filterCompleted: false,
    filterCancelled: false,
    filterRejected: false,
    isEditing: false,
    viewAppointment: false,
    appointmentData: {},
    statusFilter: -1,
    pageSize: 50,
    keyword: null,
    vispRequired: true,
    searchSimAddress: null,
    searchHardwareAddress: null,
    processCount: 0,
    menu: false,
    searchRadius: null,
    staticIpAddress: "",
    parties: [],
    nbnAssureOptions: NBN_ASSURE_OPTIONS,
    hardwareOptions: [
      {
        text: "TP-Link VX420-G2H",
        value: "TP-Link VX420-G2H",
        disabled: false
      },
      {
        text: "TP-Link VX230v",
        value: "TP-Link VX230v",
        disabled: false
      }
    ],
    historicalHardwareOptions: [
      { text: "Netcomm NL19MESH", value: "Netcomm NL19MESH", disabled: false },
      {
        text: "Netcomm NL20MESH",
        value: "Netcomm NL20MESH",
        disabled: false
      },
      {
        text: "2SG Standard VDSL Modem",
        value: "2SG Standard VDSL Modem",
        disabled: false
      }
    ],
    productType: [
      { text: "FTTP", value: "FTTP", disabled: false },
      { text: "FTTP", value: "Fibre", disabled: false },
      { text: "FTTB", value: "FTTB", disabled: false },
      { text: "FTTN", value: "FTTN", disabled: false },
      { text: "FTTC", value: "FTTC", disabled: false },
      { text: "Fixed Wireless", value: "Fixed Wireless", disabled: false },
      { text: "HFC", value: "HFC", disabled: false }
    ],
    checkType: "No",
    isRadiusUsernameExisting: false,
    isCustRefDuplicate: false,
    isAuthRefDuplicate: false,
    areAllPortsFree: false,
    isFieldRequired: false,
    connectOutstanding: false,
    isNbncoInstall: false,
    autoReplacingNtd: false,
    shouldDisplayFWAppointment:false
  }),
  // mounted() {
  //   let vm=this;
  //   var search = {
  //     keyword: null,
  //     statusFilter: -1,
  //     pageSize: 100,
  //     pageNumber: 1,
  //     wholesalerAccountNumber: vm.wholesalerAccount
  //   }
  //   vm.getOrganisationsAsync(search)
  //     .then((data) => {
  //       vm.parties = data.data.items;
  //     })
  //     .catch(() => {});
  // },
    methods: {
    hasParties() {
      let vm = this;
      const hasExistingParties = (vm.filteredParties && vm.filteredParties.length > 0);

      if (hasExistingParties) {
        return true;
      }

    const endUserType = this.nbnOrder?.endUserType;

    const hasEndUserType =
          endUserType !== null &&
          endUserType !== undefined &&
          String(endUserType).trim() !== "";

      return hasEndUserType;
      },
    isTierHigher(selectedTier, supportedTiers) {
      let vm = this;

      if (!selectedTier || !Array.isArray(supportedTiers) || supportedTiers.length === 0) {
        return false;
      }

      // supportedTiers are objects with { value, supported }, extract values
      const supportedValues = supportedTiers.map(x => x.featureType);

      // If the selected tier is directly listed as supported
      // IE. if selected tier is 250/20 and supportedTiers are 250/20, 400/40 then automatically set to true
      if (supportedValues.includes(selectedTier)) {
        if(vm.featureFlags?.sog8713 && vm.isHfc) return false;
        else return true;
      }

      // Use NWASBandwidthProfile ordering (low → high) as the rank reference
      const allTiers = BANDWIDTH_PROFILES.NWAS.map(x => x.value);
      const selectedIndex = allTiers.indexOf(selectedTier);

      // Unknown tier — can't determine, don't auto-replace
      if (selectedIndex === -1) return false;

      // Find the highest supported tier's position in the ordered list
      const supportedIndices = supportedValues
        .map(tier => allTiers.indexOf(tier))
        .filter(i => i !== -1);

      // No supported tiers found in the reference list
      if (supportedIndices.length === 0) return false;

      const maxSupportedIndex = Math.max(...supportedIndices);

      return selectedIndex > maxSupportedIndex;
    },
    onUpdateWorkforce() {
      let vm = this;
      vm.emitData("installation_workforce");
      vm.isFieldRequired =
        vm.nbnOrder.orderType === "Connect" &&
        (vm.nbnOrder.installationWorkforce !== "" ||
          vm.nbnOrder.installationWorkforce !== undefined) &&
        vm.nbnOrder.installationWorkforce === "NBN Co Install End User";

      vm.isNbncoInstall =
        vm.nbnOrder.installationWorkforce === "NBN Co Install";
    },
    resetValidation(event) {
      let vm = this;
      if (event === "No") {
        vm.checkType = "No";
        vm.disableRadio = true;
      } else {
        vm.disableRadio = false;
      }
    },
    setStaticIpByRadiusName() {
      let vm = this;
      if (
        vm.nbnOrder.radiusUsername != null &&
        vm.nbnOrder.radiusUsername !== ""
      ) {
        vm.getStaticIp(vm.nbnOrder.radiusUsername).then(data => {
          vm.staticIpAddress = data;
        });
      }
    },
    reserveAppointment() {
      let vm = this;
      vm.injectAppointmentDetail();
      vm.$refs.reserveAppointment.showNewAppointment = true;
    },
    notBeforeToday(date) {
      return date < new Date(new Date().setHours(0, 0, 0, 0));
    },
    injectAppointmentDetail() {
      let vm = this;
      vm.$refs.reserveAppointment.appointment.locationID =
        vm.nbnOrder.locationId;
      vm.$refs.reserveAppointment.appointment.phoneNumber =
        vm.nbnOrder.customerContactNumber;
      vm.$refs.reserveAppointment.appointment.contactName =
        vm.nbnOrder.customerFirstname + " " + vm.nbnOrder.customerSurname;
      vm.$refs.reserveAppointment.appointment.notes = "";
      vm.$refs.reserveAppointment.appointment.siteAccessSpecialConditions = "";
      vm.$refs.reserveAppointment.appointment.siteAccessNotes = "";
      vm.$refs.reserveAppointment.appointment.appointmentSla = "Standard";
      vm.$refs.reserveAppointment.appointment.appointmentSlotType = "AM";

      if (vm.featureFlags.sog7190) {
        if (
          vm.nbnOrder.productType === "FTTN" &&
          vm.orderItem.orderType === "Transfer"
        )
          vm.$refs.reserveAppointment.appointment.demandType =
            "Non EU Jumper Only";
        else
          vm.$refs.reserveAppointment.appointment.demandType =
            "Standard Install";
      } else {
        if (vm.ServiceClass === "12" && vm.nbnOrder.productType === "FTTN") {
          vm.$refs.reserveAppointment.appointment.demandType =
            "Non EU Jumper Only";
        } else {
          vm.$refs.reserveAppointment.appointment.demandType =
            "Standard Install";
        }
      }
    },
    queryNbnAppointment() {
      let vm = this;
      vm.$refs.queryNbnAppointment.showQueryAppointment = true;
    },
    closeNewAppointment(appointmentID) {
      let vm = this;

      if (appointmentID) {
        this.nbnOrder.appointmentId = appointmentID;
      }

      vm.$refs.reserveAppointment.showNewAppointment = false;
      vm.showNewAppointment = false;
    },
    closeQueryAppointment() {
      let vm = this;
      vm.$refs.queryNbnAppointment.showQueryAppointment = false;
      vm.showQueryAppointment = false;
    },
    checkProductType() {
      let vm = this;
      if (vm.isFibre) {
        vm.setIsFibreConnect(true);
      } else {
        vm.setIsFibreConnect(false);
      }
    },
    emitData(field = null) {
      let vm = this;
      if(!vm.featureFlags.sog8096) vm.checkProductType();
      if (field != null) {
        if (field === "Fibre Upgrade") vm.setNbnOrderType("Connect");

        if (field === "Radius Username") {
          if (vm.nbnOrder.radiusUsername && vm.vispRequired) {
            vm.checkRadiusUsername(vm.nbnOrder.radiusUsername).then(data => {
              vm.isRadiusUsernameExisting = data;
            });
          } else vm.isRadiusUsernameExisting = false;
        }

        if (field == "installation_worforce")
          vm.updateCustomizedOffer({
            field: "INSTALLATION_WORKFORCE",
            value: vm.nbnOrder.installationWorkforce
          });

        if (field === "Existing Radius Username")
          vm.getPassword(vm.nbnOrder.existingRadiusUsername);
        if (field === "Party") {
          let vm = this;
          var search = {
            keyword: null,
            wholesalerAccountNumber: vm.wholesalerAccount
          };
          if (field === "Party") {
            search.keyword = vm.nbnOrder.partyId;
          }
          vm.searchOrganisationsAsync(search)
            .then(data => {
              vm.parties = [];
              data.data.forEach(x => {
                vm.parties.push({
                  text: x.businessName + "(" + x.partyId + ")",
                  value: x.partyId,
                  disabled: false
                });
              });
            })
            .catch(() => {});
        }

        if (field === "NTD Modifications") {
          if (
            (vm.featureFlags?.sog8191 && vm.isFibre) ||
            (vm.featureFlags?.sog8713 && vm.isHfc) ||
            vm.isFixedWireless
          ) {
            vm.triggerNtdTypeUpdate();
          } else if (
            vm.nbnOrder.ntdModifications !== "USE SELECTED NTD" &&
            vm.nbnOrder.ntdModifications !== "" &&
            !vm.isOriginal &&
            !vm.autoReplacingNtd
          ) {
            vm.resetNtdType();
          }

          if(vm.featureFlags?.sog8713 && vm.isHfc){
            vm.setInstallationWorkforceOptionsNew();
          }
        }
      }

      if (vm.featureFlags.sog5947) {
        if (vm.isAppointmentMandatoryNew) vm.checkType = "Earliest";
      } else {
        if (
          (vm.nbnOrder.orderType == "Connect" ||
            vm.nbnOrder.orderType == "Transfer") &&
          (vm.isFibre || vm.isFixedWireless || vm.isHfc)
        ) {
          if (vm.nbnOrder.orderType == "Transfer") vm.checkType = "No";
          // vm.setNTD()
        }
      }

      if ((vm.isFttb || vm.isFttn) && !vm.nbnOrder.isFibreConnect) {
        if (
          vm.getCpiServiceClass.toString() === "11" ||
          vm.getCpiServiceClass.toString() === "12" ||
          (vm.isFttn && vm.nbnOrder.cpiId === "Additional Line Installation")
        ) {
          vm.setInstallationWorkforce("NBN Co Install");
        }
      }
      vm.$emit("emitNbnOrderItem", vm.nbnOrder);
    },
    triggerNtdTypeUpdate() {
      let vm = this;
      if (vm.isOriginal && vm.nbnOrder.ntdType) {
        return;
      }
      const { ntdModifications, ntdType, ntdId, orderType } = vm.nbnOrder;
      const VALID_PORTS = ["1_PORT", "4_PORT"];
        
      const resources =
        vm.sqNbnResult?.sq?.siteRestriction?.supportingResource ?? [];
        
      const selected = resources.find(r => r?.id === ntdId) || resources[0];
        
      if (ntdModifications === "USE SELECTED NTD") {
        if (vm.isFixedWireless) {
          vm.setNtdTypeFromForm(NTD_TYPE_FIXED_WIRELESS);
        } else if (selected?.NTDType) {
          vm.setNtdTypeFromForm(selected.NTDType);
        }
        return;
      }
    
      if (
        ntdModifications === "REPLACE SELECTED NTD" ||
        ntdModifications === "REQUEST NEW NTD"
      ) {
        if (vm.featureFlags?.sog8191) {
          // New Connect rule:
          // If the selected NTD is a V3 (1_PORT) and its only UNI-D port is used,
          // always request a 4_PORT NTD.
          if (
            orderType === "Connect" &&
            isV3SinglePortNtd(selected) &&
            (selected.uniPortD[0]?.status?.toUpperCase() === "USED" ||
            selected.uniPortD[0]?.status?.toUpperCase() === "FREE")
          ) {
            vm.setNtdTypeFromForm("4_PORT");
            return;
          }
        }
      
        if (vm.isHfc) {
          vm.setNtdTypeFromForm("NTD_2.5");
        } else if (vm.isFixedWireless) {
          vm.setNtdTypeFromForm(NTD_TYPE_FIXED_WIRELESS);
        } else {
          if (VALID_PORTS.includes(ntdType)) {
            vm.setNtdTypeFromForm(ntdType);
            return;
          }
        
          vm.setNtdTypeFromForm(
            vm.isFibreConnect ? "1_PORT" : "4_PORT"
          );
        }
      }
    },
    applyForcedFwNtdFields() {
      let vm = this;
      if (vm.isOriginal || !vm.isFixedWireless || vm.isPendingServiceability) {
        return;
      }

      const value = vm.resolvedFwNtdModification;
      if (!value) return;

      vm.shouldDisplayFWAppointment =
        value === NTD_MODIFICATION_OPTIONS.REPLACE_SELECTED;

      if (
        vm.nbnOrder.ntdModifications === value &&
        vm.nbnOrder.ntdType === NTD_TYPE_FIXED_WIRELESS
      ) {
        return;
      }

      vm.autoReplacingNtd = true;
      vm.setNtdModifications(value);
      vm.triggerNtdTypeUpdate();
      vm.$nextTick(() => {
        vm.autoReplacingNtd = false;
        vm.$emit("emitNbnOrderItem", vm.nbnOrder, { skipReset: true });
      });
    },
    setNTD() {
      let vm = this;
      let ntd = vm.ntdOptions.filter(x => x !== "NTD Installation Required");
      if (ntd.length > 0) {
        let status = vm.nbnOrder.orderType == "Transfer" ? "Used" : "Free";
        let selectedNtd = vm.sqNbnResult.sq.siteRestriction.supportingResource.filter(
          x => x.id == ntd[0]
        )[0];
        let port = selectedNtd.uniPortD.filter(x => x.status == status);
        vm.nbnOrder.ntdId = selectedNtd.id;
        vm.nbnOrder.portId =
          port.length > 0
            ? port[0].id.substring(port[0].id.length - 1, port[0].id.length)
            : "";
      } else {
        vm.nbnOrder.ntdId =
          vm.nbnOrder.orderType == "Connect"
            ? "Additional Line Installation"
            : "";
      }
    },
    setDefaultPort() {
      let vm = this;
      if (
        vm.nbnOrder.orderType == "Transfer" &&
        vm.ntdOptions.length > 0 &&
        (vm.isFibre || vm.isFixedWireless || vm.isHfc)
      ) {
        let selectedNtd = vm.sqNbnResult.sq.siteRestriction.supportingResource.filter(
          x =>
            x.id ==
            (vm.nbnOrder.ntdId == "" ? vm.ntdOptions[0] : vm.nbnOrder.ntdId)
        );
        let ports = selectedNtd[0].uniPortD.filter(x => x.status == "Used");
        let port = ports[0].id.substring(
          ports[0].id.length - 1,
          ports[0].id.length
        );
        if (ports.length > 0) vm.nbnOrder.portId = port;
        else vm.nbnOrder.portId = "";
      }
    },
    updateLocationId(locationId) {
      let vm = this;
      vm.nbnOrder.locationId = locationId;
    },
    checkValue(field) {
      let vm = this;

      vm.emitData();

      vm.getCustomerRefs(field).then(data => {
        if (field === "custRef") {
          if (
            data.includes(vm.nbnOrder.customerRef) &&
            vm.nbnOrder.customerRef !== null &&
            vm.nbnOrder.customerRef !== ""
          )
            vm.isCustRefDuplicate = true;
          else vm.isCustRefDuplicate = false;
        } else {
          if (
            data.includes(vm.nbnOrder.customerAuthRef.trim()) &&
            vm.nbnOrder.customerAuthRef !== null &&
            vm.nbnOrder.customerAuthRef !== ""
          )
            vm.isAuthRefDuplicate = true;
          else vm.isAuthRefDuplicate = false;
        }

        vm.setReferenceInvalid(vm.isCustRefDuplicate || vm.isAuthRefDuplicate);
      });
    },
    getPassword(radiusUserName) {
      let vm = this;
      vm.getRadiusPassword(radiusUserName).then(data => {
        vm.nbnOrder.existingRadiusPassword = data;
      });
    },
    updateContact(techDetails) {
      let vm = this;
      vm.nbnOrder.contactFirstname = techDetails.firstName;
      vm.nbnOrder.contactSurname = techDetails.lastName;
      vm.nbnOrder.contactNumber = techDetails.number;
      vm.nbnOrder.shippingType = techDetails.shippingType;
      vm.nbnOrder.authToLeave = techDetails.auth;
      vm.nbnOrder.contactEmail = techDetails.email;
      vm.nbnOrder.shippingAddress = techDetails.shipping;
      vm.emitData();
      vm.isContactValid = true;
    },
    setInstallationWorkforceOptionsNew() {
      let vm = this;
      if (
        vm.sqNbnResult.sq != null &&
        vm.sqNbnResult.sq.siteRestriction != null &&
        vm.sqNbnResult.sq.siteRestriction.supportingResource != null
      ) {
        if (vm.sqNbnResult.sq.siteRestriction.supportingResource.length === 0) {
          if (vm.formattedSQResult.serviceabilityClass === "31") {
            vm.installationWorkforces = [
              {
                text: "Pro install",
                value: "NBN Co Install",
                disabled: false
              }
            ];
          }
        } else {
          vm.sqNbnResult.sq.siteRestriction.supportingResource.forEach(x => {
            if (vm.formattedSQResult.serviceabilityClass === "34") {
              if (vm.featureFlags.sog7155) {
                if (
                  vm.nbnOrder.cpiId !== undefined &&
                  vm.nbnOrder.cpiId !== null &&
                  vm.nbnOrder.cpiId !== "" &&
                  vm.nbnOrder.cpiId !== "Additional Line Installation"
                ) {
                  if (x.id === vm.nbnOrder.cpiId) {
                    if (vm.isConnect) {
                      if (x.serviceabilityClass === "32") {
                        vm.installationWorkforces = [
                          {
                            text: "Pro install",
                            value: "NBN Co Install",
                            disabled: false
                          }
                        ];
                      } else if (
                        x.serviceabilityClass === "33" ||
                        x.serviceabilityClass === "34"
                      ) {
                        vm.installationWorkforces = [
                          {
                            text: "Pro install",
                            value: "NBN Co Install",
                            disabled: false
                          },
                          {
                            text: "NCD already on-site",
                            value: "RSP Install End User",
                            disabled: false
                          },
                          {
                            text: "Self-Installation Kit (SIK)",
                            value: "NBN Co Install End User",
                            disabled: false
                          }
                        ];
                      }
                      // else if (x.serviceabilityClass === "34"){
                      //   vm.installationWorkforces = [
                      //     {
                      //       text: "Self-Installation Kit (SIK)",
                      //       value: "NBN Co Install End User",
                      //       disabled: false
                      //     }
                      //   ];

                      //   if (vm.hasAvailableCpi)
                      //   vm.installationWorkforces.push({
                      //     text: "NCD already on-site",
                      //     value: "RSP Install End User",
                      //     disabled: false
                      //   });
                      // }
                    } else if (vm.isTransfer || vm.isTransition) {
                      vm.installationWorkforces = [
                        {
                          text: "Pro install",
                          value: "NBN Co Install",
                          disabled: false
                        },
                        {
                          text: "NCD already on-site",
                          value: "RSP Install End User",
                          disabled: false
                        },
                        {
                          text: "Self-Installation Kit (SIK)",
                          value: "NBN Co Install End User",
                          disabled: false
                        }
                      ];
                    }
                  }
                } else {
                  vm.installationWorkforces = [
                    {
                      text: "Pro install",
                      value: "NBN Co Install",
                      disabled: false
                    },
                    {
                      text: "NCD already on-site",
                      value: "RSP Install End User",
                      disabled: false
                    },
                    {
                      text: "Self-Installation Kit (SIK)",
                      value: "NBN Co Install End User",
                      disabled: false
                    }
                  ];

                  if (vm.featureFlags.sog5947 && vm.isTransition) {
                    vm.installationWorkforces = [
                      {
                        text: "Pro install",
                        value: "NBN Co Install",
                        disabled: false
                      },
                      {
                        text: "Self-Installation Kit (SIK)",
                        value: "NBN Co Install End User",
                        disabled: false
                      }
                    ];
                  }
                }
              } else {
                vm.installationWorkforces = [
                  {
                    text: "Pro install",
                    value: "NBN Co Install",
                    disabled: false
                  },
                  {
                    text: "NCD already on-site",
                    value: "RSP Install End User",
                    disabled: false
                  },
                  {
                    text: "Self-Installation Kit (SIK)",
                    value: "NBN Co Install End User",
                    disabled: false
                  }
                ];

                if (vm.featureFlags.sog5947 && vm.isTransition) {
                  vm.installationWorkforces = [
                    {
                      text: "Pro install",
                      value: "NBN Co Install",
                      disabled: false
                    },
                    {
                      text: "Self-Installation Kit (SIK)",
                      value: "NBN Co Install End User",
                      disabled: false
                    }
                  ];
                }
              }
            } else if(vm.formattedSQResult.serviceabilityClass === "24" && vm.featureFlags?.sog8713) {
              if(vm.nbnOrder.ntdModifications === "REPLACE SELECTED NTD" ||
                vm.nbnOrder.ntdModifications === "REQUEST NEW NTD"
              ) {
                vm.installationWorkforces = [
                  {
                    text: "Pro install",
                    value: "NBN Co Install",
                    disabled: false
                  },
                  {
                    text: "Self-Installation Kit (SIK)",
                    value: "NBN Co Install End User",
                    disabled: false
                  }
                ];
              } else {
                vm.installationWorkforces = [
                  {
                    text: "NCD already on-site",
                    value: "NBN Co Install",
                    disabled: false
                  }
                ];

                if (vm.featureFlags.sog5947) vm.updateOnSiteLabel();
              }
            } else {
              if (x.id === vm.nbnOrder.cpiId) {
                if (
                  x.serviceabilityClass === "32" ||
                  x.serviceabilityClass === "31"
                ) {
                  vm.installationWorkforces = [
                    {
                      text: "Pro install",
                      value: "NBN Co Install",
                      disabled: false
                    }
                  ];
                } else {
                  vm.installationWorkforces = [
                    {
                      text: "Pro install",
                      value: "NBN Co Install",
                      disabled: false
                    },
                    {
                      text: "NCD already on-site",
                      value: "RSP Install End User",
                      disabled: false
                    },
                    {
                      text: "Self-Installation Kit (SIK)",
                      value: "NBN Co Install End User",
                      disabled: false
                    }
                  ];
                }
              } else if (
                vm.nbnOrder.cpiId === "Additional Line Installation" &&
                vm.isFttn
              ) {
                vm.installationWorkforces = [
                  {
                    text: "Pro install",
                    value: "NBN Co Install",
                    disabled: false
                  }
                ];
              }
            }
          });
        }
      } else if (
        vm.sqNbnResult.sq.siteRestriction.supportingResource === undefined &&
        vm.formattedSQResult.serviceabilityClass === "31"
      ) {
        vm.installationWorkforces = [
          {
            text: "Pro install",
            value: "NBN Co Install",
            disabled: false
          }
        ];
      }

      if(vm.featureFlags?.sog8713 && vm.isHfc && vm.installationWorkforces.length === 1)
        vm.setInstallationWorkforce(vm.installationWorkforces[0].value);
    },
    updateOnSiteLabel() {
      let vm = this;
      if (vm.featureFlags.sog4570 && vm.nbnOrder.productType === "HFC") {
        vm.installationWorkforces.forEach(x => {
          if (x.text === "NCD already on-site") x.text = "NTD already on-site";
        });
      } else {
        vm.installationWorkforces.forEach(x => {
          if (x.text === "NTD already on-site") x.text = "NCD already on-site";
        });
      }
    },

    setAssureOptions() {
      let vm = this;
      try {
        vm.getWholesalers().then(data => {
          if (data.length > 0) {
            const foundAccountNumber = data.find(
              x => x.accountNumber === DEFAULT_VONEX_ACCOUNT_NUMBER
            );

            if (
              vm.isAdmin ||
              (vm.isOriginal && this.nbnAssureOptions.length < 2) ||
              foundAccountNumber
            ) {
              this.nbnAssureOptions.unshift({
                text: "Basic",
                value: "Basic",
                disabled: false
              });
            }
            
          }
        });
      } catch (error) {
        // Handle error silently or emit error event
        this.$emit("error", error);
      }
    },

    checkBandwidth(bandwidth) {
      let bandwidthArray = [...bandwidth];
      let vm = this;
      try {
        let selectedNTD = vm.sqNbnResult.sq.siteRestriction.supportingResource.find(
          x => x.id === vm.nbnOrder.ntdId
        );
        if (selectedNTD != null) {
          let remainingCapacity = selectedNTD.ntdDetails.find(
            x => x.name == "Remaining Capacity Downstream"
          )?.rawValue;
          if (remainingCapacity) {
            bandwidthArray = bandwidthArray.filter(option => {
              let splitValue = option.text.split("/");
              let downstream = parseInt(splitValue[0]);
              return downstream > remainingCapacity;
            });
          }
        }
      } catch (error) {
        // Handle error silently
      }
      return bandwidthArray;
    }
  },

  mounted() {
    this.setAssureOptions();
  },

  computed: {
    ntdVersion() {
      let vm = this;
      const resource = vm.sqNbnResult?.sq?.siteRestriction?.supportingResource;

      if (!Array.isArray(resource) || resource.length === 0) return "";

      // if you need the selected NTD by ntdId, use this:
      const selected = resource.find(x => x?.id === vm.nbnOrder?.ntdId) ?? resource[0];
      return selected?.NTDVersion ?? "";
    },
    speedTiersSupported() {
        let vm = this;
        try {
          const resource = vm.sqNbnResult?.sq?.siteRestriction?.supportingResource;

          if (!Array.isArray(resource) || resource.length === 0) return [];

          const selected = resource.find(x => x?.id === vm.nbnOrder?.ntdId) ?? resource[0];
          const tiers = selected?.speedTiersSupported;

          if (!Array.isArray(tiers) || tiers.length === 0) return [];

          let filteredTiers = tiers.filter(x => x.supported === true);
          return filteredTiers;
        } catch (e) {
          return [];
        }
     },
    currentFwNtd() {
      let vm = this;
      const resources =
        vm.sqNbnResult?.sq?.siteRestriction?.supportingResource ?? [];
      if (!Array.isArray(resources) || resources.length === 0) return null;
      return resources.find(x => x?.id === vm.nbnOrder?.ntdId) ?? resources[0];
    },
     isV1OrV2Ntd() {
      let vm = this;
      const version = vm.isFixedWireless
        ? inferFixedWirelessNtdVersion(vm.currentFwNtd)
        : (vm.ntdVersion || "").toUpperCase().trim();
      return version === "V1" || version === "V2";
     },
    isBandwidthWithinSupported() {
      let vm = this;
      const supported = vm.speedTiersSupported;

      if (vm.isFixedWireless) {
        return doesFwSpeedExceedNtd(vm.nbnOrder.bandwidthProfile, supported);
      }
   
      if (supported.length === 0) return false;
      return vm.isTierHigher(vm.nbnOrder.bandwidthProfile, supported);
    },
    resolvedFwNtdModification() {
      let vm = this;
      if (!vm.isFixedWireless || vm.isOriginal) return "";

      return getForcedFixedWirelessNtdModification({
        ntdId: vm.nbnOrder.ntdId,
        currentNtd: vm.currentFwNtd,
        orderType: vm.nbnOrder.orderType,
        bandwidthProfile: vm.nbnOrder.bandwidthProfile,
        speedTiersSupported: vm.speedTiersSupported
      });
    },
    shouldAutoReplaceSelectedNtd() {
      let vm = this;
      if (vm.isFibre && vm.nbnOrder.orderType?.toLowerCase() === "transfer") {
        return false;
      }
      if (vm.isFixedWireless) {
        return (
          vm.resolvedFwNtdModification ===
          NTD_MODIFICATION_OPTIONS.REPLACE_SELECTED
        );
      }
      return vm.isV1OrV2Ntd && vm.isBandwidthWithinSupported;
    },
    orderTypeFilterNew() {
      let vm = this;

      let newOrderTypes = [];

      if (vm.isOriginal) {
        newOrderTypes = NBN_ORDER_TYPES.filter(
          x => x.value.toLowerCase() == vm.nbnOrder.orderType.toLowerCase()
        );
      } else {
        if (vm.nbnOrder.isFibreConnect != undefined && vm.nbnOrder.isFibreConnect){
          newOrderTypes = NBN_ORDER_TYPES.filter(
            x => x.value.toLowerCase() == "connect"
          );
        }
        else {
          if (
            vm.sqNbnResult.sq != null &&
            vm.sqNbnResult.sq.siteRestriction != null &&
            vm.sqNbnResult.sq.siteRestriction.supportingResource != null &&
            vm.sqNbnResult.sq.siteRestriction.supportingResource.length > 0
          ) {
            if (vm.isFttn || vm.isFttb || vm.isFttc) {
              if (!newOrderTypes.find(y => y.value === "Connect"))
                newOrderTypes.push({
                  text: "Connect",
                  value: "Connect",
                  disabled: false
                });

              vm.sqNbnResult.sq.siteRestriction.supportingResource.forEach(
                x => {
                  if (
                    x.serviceabilityClass !== "13" &&
                    x.serviceabilityClass !== "34"
                  ) {
                    if (
                      x.copperPairStatus == "Active" &&
                      !newOrderTypes.find(y => y.value === "Transition")
                    )
                      newOrderTypes.push({
                        text: "Transition",
                        value: "Transition",
                        disabled: false
                      });
                  }

                  if (
                    x.copperPairStatus == "Active" &&
                    x.NBNServiceStatus === "Line In Use" &&
                    !newOrderTypes.find(y => y.value === "Transfer")
                  )
                    newOrderTypes.push({
                      text: "Transfer",
                      value: "Transfer",
                      disabled: false
                    });
                }
              );
            } else {
              if (vm.isFibre || vm.isFixedWireless || vm.isHfc) {
                if (vm.ServiceClass === "23" && !vm.hasNtd)
                  newOrderTypes = NBN_ORDER_TYPES.filter(
                    x =>
                      x.value.toLowerCase() == "transition" ||
                      x.value.toLowerCase() == "connect"
                  );
                else {
                  newOrderTypes = NBN_ORDER_TYPES.filter(
                    x =>
                      x.value.toLowerCase() == "connect" ||
                      x.value.toLowerCase() == "transfer"
                  );
                }

                if (
                  vm.areAllPortsFree ||
                  vm.sqNbnResult.sq.siteRestriction.supportingResource === null
                ) {
                  newOrderTypes = NBN_ORDER_TYPES.filter(
                    x => x.value.toLowerCase() == "connect"
                  );
                }
              } else {
                if (
                  vm.sqNbnResult.sq != null &&
                  vm.sqNbnResult.sq.siteRestriction != null &&
                  vm.sqNbnResult.sq.siteRestriction.supportingResource !=
                    null &&
                  vm.sqNbnResult.sq.siteRestriction.supportingResource.length >
                    0
                ) {
                  var inUseCount = 0;
                  vm.sqNbnResult.sq.siteRestriction.supportingResource.forEach(
                    x => {
                      if (x.NBNServiceStatus == "Line In Use") inUseCount++;
                    }
                  );
                  if (inUseCount === 0)
                    newOrderTypes = NBN_ORDER_TYPES.filter(
                      x => x.value.toLowerCase() !== "transfer"
                    );
                }
              }
            }
          } else {
            newOrderTypes = NBN_ORDER_TYPES.filter(
              x => x.value.toLowerCase() == "connect"
            );
          }
        }
      }

      return newOrderTypes;
    },
    isBusinessOrder() {
      let vm = this;
      if (
        vm.nbnOrder.endUserType != null &&
        vm.nbnOrder.endUserType == "Business"
      ) {
        return true;
      }
      return false;
    },
    getLabels() {
      let vm = this;
      let options = [
        {
          label: "NO",
          value: "No"
        },
        {
          label: "YES - Earliest",
          value: "Earliest"
        },
        {
          label: "YES - Customize Appointment",
          value: "Customize"
        }
      ];

      if (vm.isFttc) {
        let isInactiveAvailable = false;
        let isActiveInUse = false;
        let cpiItem = vm.sqNbnResult.sq.siteRestriction.supportingResource.filter(
          x => x.id === vm.nbnOrder.cpiId
        );
        if (cpiItem !== null && cpiItem.length === 1) {
          isInactiveAvailable =
            cpiItem[0].NBNServiceStatus === "Line Not In Use" &&
            cpiItem[0].copperPairStatus === "Inactive";
          isActiveInUse =
            cpiItem[0].NBNServiceStatus === "Line In Use" &&
            cpiItem[0].copperPairStatus === "Active";
        }
        if (
          vm.sqNbnResult.sq.siteRestriction.supportingResource === undefined ||
          vm.sqNbnResult.sq.siteRestriction.supportingResource.length === 0
        ) {
          vm.checkType = "Earliest";
          return options.filter(x => x.value != "No");
        } else {
          if (
            vm.formattedSQResult.serviceabilityClass === "30" ||
            vm.formattedSQResult.serviceabilityClass === "31"
          ) {
            vm.checkType = "Earliest";
            return options.filter(x => x.value != "No");
          } else if (
            vm.formattedSQResult.serviceabilityClass === "32" ||
            vm.formattedSQResult.serviceabilityClass === "33"
          ) {
            if (isInactiveAvailable) {
              vm.checkType = "Earliest";
              return options.filter(x => x.value != "No");
            }
          } else if (vm.formattedSQResult.serviceabilityClass === "34") {
            if (isActiveInUse) return options;
          }
        }
      } else {
        if (vm.isHfc || vm.nbnOrder.isFibreConnect || vm.checkTechnologyRules)
          return options.filter(x => x.value != "No");
      }

      return options;
    },
    getLabelsNew() {
      let vm = this;
      let options = [
        {
          label: "NO",
          value: "No"
        },
        {
          label: "YES - Earliest",
          value: "Earliest"
        },
        {
          label: "YES - Customize Appointment",
          value: "Customize"
        }
      ];

      if (
        vm.sqNbnResult.sq != null &&
        vm.sqNbnResult.sq.siteRestriction != null &&
        vm.sqNbnResult.sq.siteRestriction.supportingResource != null &&
        vm.sqNbnResult.sq.siteRestriction.supportingResource.length > 0
      ) {
        if (vm.isNbncoInstall && vm.featureFlags.sog5947) {
          vm.checkType = "Earliest";
          return options.filter(x => x.value != "No");
        } else {
          if (
            vm.isFttc ||
            vm.isFttn ||
            (vm.isFttb && vm.featureFlags.sog5947)
          ) {
            let isInactiveAvailable = false;
            let isActiveInUse = false;
            let cpiItem = vm.sqNbnResult.sq.siteRestriction.supportingResource.filter(
              x => x.id === vm.nbnOrder.cpiId
            );
            if (cpiItem !== null && cpiItem.length === 1) {
              isInactiveAvailable =
                cpiItem[0].NBNServiceStatus === "Line Not In Use" &&
                cpiItem[0].copperPairStatus === "Inactive";
              isActiveInUse =
                cpiItem[0].NBNServiceStatus === "Line In Use" &&
                cpiItem[0].copperPairStatus === "Active";
            }

            if (
              vm.sqNbnResult.sq.siteRestriction.supportingResource ===
                undefined ||
              vm.sqNbnResult.sq.siteRestriction.supportingResource.length ===
                0 ||
              (vm.nbnOrder.installationWorkforce === "NBN Co Install" &&
                vm.featureFlags.sog5947)
            ) {
              vm.checkType = "Earliest";
              return options.filter(x => x.value != "No");
            } else {
              if (
                (vm.formattedSQResult.serviceabilityClass === "13" &&
                  vm.nbnOrder.cpiId === "Additional Line Installation") ||
                vm.formattedSQResult.serviceabilityClass === "30" ||
                vm.formattedSQResult.serviceabilityClass === "31"
              ) {
                vm.checkType = "Earliest";
                return options.filter(x => x.value != "No");
              } else if (
                vm.formattedSQResult.serviceabilityClass === "32" ||
                vm.formattedSQResult.serviceabilityClass === "33" ||
                vm.formattedSQResult.serviceabilityClass === "12"
              ) {
                if (isInactiveAvailable) {
                  vm.checkType = "Earliest";
                  return options.filter(x => x.value != "No");
                }
              } else if (vm.formattedSQResult.serviceabilityClass === "34") {
                if (isActiveInUse) return options;
              } else if (vm.formattedSQResult.serviceabilityClass === "13")
                vm.checkType = "No";
            }
          } else {
            if (
              vm.isHfc ||
              vm.nbnOrder.isFibreConnect ||
              vm.checkTechnologyRules
            )
              return options.filter(x => x.value != "No");
            else if (
              vm.isFixedWireless &&
              vm.nbnOrder.ntdId === "NTD Installation Required" &&
              vm.featureFlags.sog5947
            ) {
              vm.checkType = "Earliest";
              return options.filter(x => x.value != "No");
            }
          }
        }
      } else {
        vm.checkType = "Earliest";
        return options.filter(x => x.value != "No");
      }

      return options;
    },
    isNCAS() {
      let vm = this;
      if (
        vm.nbnOrder.productType != null &&
        (vm.nbnOrder.productType === "FTTB" ||
          vm.nbnOrder.productType === "FTTC" ||
          vm.nbnOrder.productType === "FTTN")
      ) {
        return true;
      } else {
        return false;
      }
    },
    isEE() {
      let vm = this;
      if (
        vm.nbnOrder.productType != null &&
        vm.nbnOrder.productType === "Enterprise Ethernet"
      ) {
        return true;
      } else {
        return false;
      }
    },
    isDisconnect() {
      let vm = this;
      if (
        vm.nbnOrder.orderType != null &&
        vm.nbnOrder.orderType === "disconnect"
      ) {
        return true;
      } else {
        return false;
      }
    },
    showAuthReference() {
      let vm = this;
      return !vm.isDisconnect && vm.featureFlags.sog5795;
    },
    isTransfer() {
      let vm = this;
      if (
        vm.nbnOrder.orderType != null &&
        vm.nbnOrder.orderType === "Transfer"
      ) {
        return true;
      } else {
        return false;
      }
    },
    isTransition() {
      let vm = this;
      if (
        vm.nbnOrder.orderType != null &&
        vm.nbnOrder.orderType === "Transition"
      ) {
        return true;
      } else {
        return false;
      }
    },
    isHfcRspInstall() {
      let vm = this;
      return (
        vm.isHfc &&
        vm.isConnect &&
        vm.nbnOrder.installationWorkforce === "RSP Install End User"
      );
    },
    isConnect() {
      let vm = this;
      if (
        vm.nbnOrder.orderType != null &&
        vm.nbnOrder.orderType === "Connect"
      ) {
        return true;
      } else {
        return false;
      }
    },
    hasNtd() {
      let vm = this;
      if (vm.nbnOrder.ntdId != undefined && vm.nbnOrder.ntdId !== "") {
        return true;
      } else {
        return false;
      }
    },
    isFttc() {
      let vm = this;
      return vm.sqNbnResult.sq
        ? vm.sqNbnResult.sq.siteRestriction.supportingTechnology
            .primaryAccessTechnology === "Fibre To The Curb"
        : false;
    },
    isFttp() {
      let vm = this;
      const technology =
        vm.sqNbnResult.sq?.siteRestriction?.supportingTechnology
          ?.primaryAccessTechnology;
      return technology === "Fibre" || technology === "FTTP";
    },
    isFibre() {
      let vm = this;
      if (vm.nbnOrder.isFibreConnect) return true;
      const technology =
        vm.sqNbnResult.sq?.siteRestriction?.supportingTechnology
          ?.primaryAccessTechnology;
      return technology === "Fibre" || technology === "FTTP";
    },
    isHfc() {
      let vm = this;
      return vm.sqNbnResult.sq
        ? vm.sqNbnResult.sq.siteRestriction.supportingTechnology
            .primaryAccessTechnology === "HFC"
        : false;
    },
    isFttn() {
      let vm = this;
      return vm.sqNbnResult.sq
        ? vm.sqNbnResult.sq.siteRestriction.supportingTechnology
            .primaryAccessTechnology === "Fibre To The Node"
        : false;
    },
    isFttb() {
      let vm = this;
      return vm.sqNbnResult.sq
        ? vm.sqNbnResult.sq.siteRestriction.supportingTechnology
            .primaryAccessTechnology === "Fibre To The Building"
        : false;
    },
    isFixedWireless() {
      let vm = this;
      return vm.sqNbnResult.sq
        ? vm.sqNbnResult.sq.siteRestriction.supportingTechnology
            .primaryAccessTechnology === "Wireless"
        : false;
    },
    isNtdRequired() {
      let vm = this;
      return (
        (vm.nbnOrder.orderType === "Transfer" &&
          (vm.isFibre || vm.isFixedWireless || vm.isHfc)) ||
        vm.nbnOrder.isFibreConnect
      );
    },
    isNtdModificationsRequired() {
      let vm = this;
      return vm.isFibre && vm.nbnOrder.isFibreConnect;
    },
    isNtdTypeRequired() {
      let vm = this;
      return vm.nbnOrder.ntdType === "" || vm.nbnOrder.ntdType === null;
    },
    isCpiRequired() {
      let vm = this;
      return (
        vm.cpiOptions.length > 0 &&
        (((vm.nbnOrder.orderType === "Transfer" ||
          vm.nbnOrder.orderType === "Connect") &&
          vm.isFttc) ||
          vm.isFttb ||
          vm.isFttn) &&
        !vm.nbnOrder.isFibreConnect
      );
    },
    isReadonly() {
      let vm = this;
      return (
        vm.isFttc ||
        vm.isFibre ||
        vm.isHfc ||
        vm.isFttn ||
        vm.isFttb ||
        vm.isFixedWireless
      );
    },
    hasFreeNtd() {
      let vm = this;
      let count = 0;
      let portCount = 0;
      vm.checkType = "No";
      if (
        vm.featureFlags.sog5947 &&
        SERVICE_CLASS_REQUIRED_APPOINTMENT.includes(vm.ServiceClass)
      )
        vm.checkType = "Earliest";
      if (vm.sqNbnResult.sq) {
        if (
          vm.sqNbnResult.sq.siteRestriction.supportingTechnology
            .serviceabilityClass === "3" ||
          vm.sqNbnResult.sq.siteRestriction.supportingTechnology
            .serviceabilityClass === "6" ||
          (vm.sqNbnResult.sq.siteRestriction.supportingTechnology
            .serviceabilityClass === "24" &&
            vm.featureFlags.sog5947)
        ) {
          if (vm.featureFlags.sog5947) {
            vm.sqNbnResult.sq.siteRestriction.supportingResource.forEach(x => {

              if (x.type.toLowerCase() == "ntd") {
                x.uniPortD.forEach(uniPortD => {
                  uniPortD.status.toLowerCase() == "free"
                    ? (count += 1)
                    : count;
                  portCount++;
                });
              } else {
                x.uniPortD.forEach(() => {
                  portCount++;
                });
              }
            });

            if (count === 0) vm.checkType = "Earliest";
            vm.areAllPortsFree = count === portCount;
          } else {
            vm.sqNbnResult.sq.siteRestriction.supportingResource.forEach(x => {
              if (x.type.toLowerCase() == "ntd") {
                x.uniPortD.forEach(uniPortD => {
                  uniPortD.status.toLowerCase() == "free"
                    ? (count += 1)
                    : count;
                });
              }
            });

            if (count === 0) vm.checkType = "Earliest";
            vm.areAllPortsFree = vm.featureFlags.sog5947
              ? count === portCount
              : count ===
                vm.sqNbnResult.sq.siteRestriction.supportingResource[0].uniPortD
                  .length;
          }
        } else {
          count = 1;
        }
      }

      return count > 0;
    },
    hasUsedPort() {
      let vm = this;
      let usedCount = 0;
      if (
        vm.isFibre &&
        (vm.nbnOrder.ntdId !== "" || vm.nbnOrder.ntdId !== null) &&
        vm.nbnOrder.orderType === "Connect"
      ) {
        vm.sqNbnResult.sq.siteRestriction.supportingResource.forEach(x => {
          if (x.id === vm.nbnOrder.ntdId) {
            x.uniPortD.forEach(port => {
              if (port.status === "Used") usedCount++;
            });
          }
        });
      }
      return usedCount > 0;
    },
    portsOnNtd() {
      let vm = this;
      let usedCount = 0;
      if (
        vm.isFibre &&
        (vm.nbnOrder.ntdId !== "" || vm.nbnOrder.ntdId !== null) &&
        vm.nbnOrder.orderType === "Connect"
      ) {
        vm.sqNbnResult.sq.siteRestriction.supportingResource.forEach(x => {
          if (x.id === vm.nbnOrder.ntdId) {
            x.uniPortD.forEach(() => {
              usedCount++;
            });
          }
        });
      }
      return usedCount;
    },

    getCpiServiceClass() {
      let vm = this;
      let serviceClass = "";

      if (vm.nbnOrder.cpiId !== "" || vm.isFttb || vm.isFttn || vm.isFttc) {
        if (
          vm.sqNbnResult.sq != null &&
          vm.sqNbnResult.sq.siteRestriction != null &&
          vm.sqNbnResult.sq.siteRestriction.supportingTechnology != null
        ) {
          serviceClass =
            vm.sqNbnResult.sq.siteRestriction.supportingTechnology
              .serviceabilityClass;
        }
      } else serviceClass = vm.getNtdServiceClass();

      return serviceClass;
    },
    getNtdServiceClass() {
      let vm = this;
      let serviceClass = "";
      if (vm.nbnOrder.ntdId !== "") {
        if (vm.sqNbnResult.sq != null) {
          serviceClass =
            vm.sqNbnResult.sq.siteRestriction.supportingTechnology
              .serviceabilityClass;
        }
      }
      return serviceClass;
    },

    getCurrentNtdType() {
      const vm = this;
      try {
        const currentNtd = vm.sqNbnResult.sq?.siteRestriction?.supportingResource?.find(
          x => x.id === vm.nbnOrder.ntdId
        );
        return currentNtd?.NTDType ?? "No NTD Type";
      } catch (error) {
        return "No NTD Type";
      }
    },
    isAppointmentMandatory() {
      let vm = this;

      return vm.isOriginal
        ? vm.nbnOrder.appointmentId !== null && vm.nbnOrder.appointmentId !== ""
        : (vm.nbnOrder.orderType === "Connect" &&
            vm.isFttc &&
            vm.nbnOrder.cpiId != null &&
            vm.getCpiServiceClass.toString() === "32") ||
            (vm.nbnOrder.orderType === "Connect" &&
              vm.isHfc &&
              vm.getNtdServiceClass.toString() === "22") ||
            (vm.nbnOrder.orderType === "Connect" &&
              !vm.isHfc &&
              vm.nbnOrder.installationWorkforce != null &&
              vm.nbnOrder.installationWorkforce === "NBN Co Install" &&
              vm.getCpiServiceClass.toString() !== "24") ||
            (!vm.isFttc && !vm.isHfc) ||
            vm.nbnOrder.isFibreConnect;
    },
    isAppointmentMandatoryNew() {
      let vm = this;
      let result = false;

      if (vm.featureFlags.sog5947) {
        if (
          ((vm.sqNbnResult &&
            vm.sqNbnResult.sq.siteRestriction.supportingResource === null) ||
            SERVICE_CLASS_REQUIRED_APPOINTMENT.includes(vm.ServiceClass)) &&
          vm.nbnOrder.orderType !== "Transfer"
        ) {
          result = true;
          vm.checkType = "Earliest";
        } else if (
          (vm.ServiceClass === "3" || vm.ServiceClass === "6") &&
          (vm.nbnOrder.ntdModifications === "REQUEST NEW NTD" ||
            vm.nbnOrder.ntdId !== "Additional NTD Required") &&
          (vm.getCurrentNtdType === "INTERNAL" ||
            vm.getCurrentNtdType === "1_PORT")
        ) {
          result = true;
          vm.checkType = "Earliest";
        } else if (
          (vm.ServiceClass === "3" || vm.ServiceClass === "6") &&
          vm.nbnOrder.ntdId !== "Additional NTD Required" &&
          vm.getCurrentNtdType !== "INTERNAL" &&
          vm.getCurrentNtdType !== "1_PORT"
        ) {
          result = false;
          vm.checkType = "No";
        } else {
          let con1 =
            vm.nbnOrder.orderType === "Connect" &&
            vm.isFttc &&
            vm.nbnOrder.cpiId != null &&
            vm.getCpiServiceClass.toString() === "32";
          let con2 =
            vm.nbnOrder.orderType === "Connect" &&
            vm.isHfc &&
            vm.getNtdServiceClass.toString() === "22";
          let con3 =
            vm.nbnOrder.orderType === "Connect" &&
            !vm.isHfc &&
            vm.isNbncoInstall &&
            vm.getCpiServiceClass.toString() !== "24";
          let con4 = !vm.isFttc && !vm.isHfc && !vm.isFibre;
          let con5 = vm.nbnOrder.isFibreConnect;
          let con6 = vm.isFibre && !vm.hasUsedPort;
          let con7 =
            (vm.isNbncoInstall && !vm.isHfc) ||
            (vm.isNbncoInstall &&
              vm.isHfc &&
              ((vm.nbnOrder.replaceNtd !== undefined &&
                vm.nbnOrder.replaceNtd &&
                vm.ServiceClass === "24") ||
                vm.ServiceClass !== "24"));
          let con8 = vm.nbnOrder.orderType !== "Transfer";

          result =
            (con1 || con2 || con3 || con4 || con5 || con6 || con7) && con8;

          if (!result) vm.checkType = "No";
          else {
            if (con7) vm.checkType = "Earliest";
          }
        }

        return vm.isOriginal
          ? vm.nbnOrder.appointmentId !== null &&
              vm.nbnOrder.appointmentId !== ""
          : result;
      } else {
        return vm.isOriginal
          ? vm.nbnOrder.appointmentId !== null &&
              vm.nbnOrder.appointmentId !== ""
          : ((vm.nbnOrder.orderType === "Connect" &&
              vm.isFttc &&
              vm.nbnOrder.cpiId != null &&
              vm.getCpiServiceClass.toString() === "32") ||
              (vm.nbnOrder.orderType === "Connect" &&
                vm.isHfc &&
                vm.getNtdServiceClass.toString() === "22") ||
              (vm.nbnOrder.orderType === "Connect" &&
                !vm.isHfc &&
                vm.nbnOrder.installationWorkforce != null &&
                vm.nbnOrder.installationWorkforce === "NBN Co Install" &&
                vm.getCpiServiceClass.toString() !== "24") ||
              (!vm.isFttc && !vm.isHfc && !vm.isFibre) ||
              vm.nbnOrder.isFibreConnect ||
              (vm.isFibre && !vm.hasUsedPort)) &&
              vm.nbnOrder.orderType !== "Transfer";
      }
    },
    needRemoveAppointmentDetail() {
      let vm = this;
      let result = false;
      if (vm.isFttc) {
        let isInactiveAvailable = false;
        let isActiveInUse = false;
        let cpiItem = vm.sqNbnResult.sq.siteRestriction.supportingResource.filter(
          x => x.id === vm.nbnOrder.cpiId
        );

        if (cpiItem !== null && cpiItem.length === 1) {
          isInactiveAvailable =
            cpiItem[0].NBNServiceStatus === "Line Not In Use" &&
            cpiItem[0].copperPairStatus === "Inactive";
          isActiveInUse =
            cpiItem[0].NBNServiceStatus === "Line In Use" &&
            cpiItem[0].copperPairStatus === "Active";
        }

        if (
          vm.sqNbnResult.sq.siteRestriction.supportingResource === undefined ||
          vm.sqNbnResult.sq.siteRestriction.supportingResource.length === 0
        ) {
          result = true;
        } else {
          if (
            vm.formattedSQResult.serviceabilityClass === "30" ||
            vm.formattedSQResult.serviceabilityClass === "31"
          ) {
            result = true;
          } else if (
            vm.formattedSQResult.serviceabilityClass === "32" ||
            vm.formattedSQResult.serviceabilityClass === "33"
          ) {
            if (isInactiveAvailable) result = true;
          } else if (vm.formattedSQResult.serviceabilityClass === "34") {
            if (vm.featureFlags.sog5947 && vm.isTransfer) {
              result = false;
            } else {
              if (vm.featureFlags.sog6522) result = true;
              else if (isActiveInUse) result = true;
            }
          }
        }

        if (vm.nbnOrder.isFibreConnect) {
          result = false;
        }
      } else {
        result =
          vm.nbnOrder.orderType === "Connect" &&
          (vm.isHfc ||
            (vm.isFttn &&
              vm.nbnOrder.cpiId === "Additional Line Installation")) &&
          !vm.nbnOrder.isFibreConnect;
      }

      return result;
    },
    hasVispCredentials() {
      let vm = this;

      return (
        vm.nbnOrder.radiusUsername !== null &&
        vm.nbnOrder.radiusPassword !== null &&
        vm.nbnOrder.radiusUsername !== "" &&
        vm.nbnOrder.radiusPassword !== "" &&
        vm.nbnOrder.radiusPassword !== undefined &&
        vm.nbnOrder.radiusPassword !== undefined
      );
    },
    hasAvailableCpi() {
      let vm = this;
      if (
        vm.sqNbnResult.sq != null &&
        vm.sqNbnResult.sq.siteRestriction != null &&
        vm.sqNbnResult.sq.siteRestriction.supportingResource != null &&
        vm.sqNbnResult.sq.siteRestriction.supportingResource.length > 0
      ) {
        return (
          vm.sqNbnResult.sq.siteRestriction.supportingResource.filter(
            x =>
              x.NBNServiceStatus == "Line Not In Use" &&
              x.copperPairStatus == "Active"
          ).length > 0
        );
      }

      return false;
    },
    cpiOptions() {
      let vm = this;
      let result = [];
      let inactiveCopperPairsPresent = false;

      try {
        if (
          vm.sqNbnResult.sq != null &&
          vm.sqNbnResult.sq.siteRestriction != null &&
          vm.sqNbnResult.sq.siteRestriction.supportingResource != null &&
          vm.sqNbnResult.sq.siteRestriction.supportingResource.length > 0
        ) {
          vm.sqNbnResult.sq.siteRestriction.supportingResource.forEach(x => {
            if (vm.isTransfer) {
              if (
                x.NBNServiceStatus === "Line In Use" &&
                x.serviceabilityClass != "33" &&
                x.serviceabilityClass != "11" &&
                x.serviceabilityClass != "31" &&
                x.serviceabilityClass != "12"
              ) {
                result.push(x.id);
              }
            } else if (vm.isConnect) {
              result.push("Additional Line Installation");

              if (
                x.serviceabilityClass === "13" ||
                x.serviceabilityClass === "33" ||
                x.serviceabilityClass === "34"
              ) {
                if (
                  (x.NBNServiceStatus === undefined ||
                    x.NBNServiceStatus === "Line Not In Use") &&
                  x.copperPairStatus === "Active"
                )
                  result.push(x.id);
              }
              if (
                x.serviceabilityClass === "32" ||
                x.serviceabilityClass === "33" ||
                x.serviceabilityClass === "34" ||
                x.serviceabilityClass === "12"
              ) {
                if (
                  (x.NBNServiceStatus === undefined ||
                    x.NBNServiceStatus !== "Line In Use") &&
                  x.copperPairStatus === "Inactive"
                ) {
                  inactiveCopperPairsPresent = true;
                  result.push(x.id);
                }
              }
            } else if (vm.isTransition) {
              if (
                !(
                  x.serviceabilityClass === "33" &&
                  x.serviceabilityClass !== "11" &&
                  x.serviceabilityClass !== "31"
                ) &&
                x.serviceabilityClass !== "13" &&
                x.serviceabilityClass !== "34" &&
                x.copperPairStatus == "Active" &&
                (x.NBNServiceStatus == undefined ||
                  x.NBNServiceStatus !== "Line In Use")
              ) {
                result.push(x.id);
              } else {
                if (
                  (x.serviceabilityClass === "33" ||
                    x.serviceabilityClass === "34") &&
                  vm.featureFlags.sog5947
                ) {
                  if (
                    (x.NBNServiceStatus === undefined ||
                      x.NBNServiceStatus === "Line Not In Use") &&
                    x.copperPairStatus === "Active"
                  ) {
                    result.push(x.id);
                  }
                }
              }
            }
          });

          var lineNotInUse = vm.sqNbnResult.sq.siteRestriction.supportingResource.filter(
            x => x.NBNServiceStatus === "Line Not In Use"
          );

          if (vm.nbnOrder.orderType == "Connect" && lineNotInUse.length > 0) {
            var filteredResult = result.filter(x => {
              if (!inactiveCopperPairsPresent && vm.isFttn) {
                return x !== "New Line Installation";
              }
              return (
                x !== "Additional Line Installation" &&
                x !== "New Line Installation"
              );
            });

            if (filteredResult.length == 0) return result;
            else return filteredResult;
          }
        } else {
          if (!vm.isOriginal) result.push("New Line Installation");
        }

        if (vm.isOriginal) {
          result.push(vm.nbnOrder.cpiId);
        }

        if (vm.isFttn) {
          vm.setCpiId(vm.sqNbnResult);
        }
      } catch (e) {
        // Handle error silently
      }

      return result;
    },
    
    ntdOptions() {
      let vm = this;
        
      let result = [];
      const serviceClass =
        vm.sqNbnResult?.sq?.siteRestriction?.supportingTechnology
          ?.serviceabilityClass || "";
    
      if (vm.nbnOrder.orderType === "Connect") {
        if (
          serviceClass === "1" ||
          serviceClass === "2" ||
          serviceClass === "5"
        ) {
          if (vm.isOriginal && isRealNtdId(vm.nbnOrder.ntdId)) {
            result.push(vm.nbnOrder.ntdId);
          } else {
            result.push("NTD Installation Required");
          }
          return result;
        }
      }

      if(vm.featureFlags?.sog8191){
        const supportingResources =
          vm.sqNbnResult?.sq?.siteRestriction?.supportingResource || [];

        if (vm.nbnOrder.orderType === "Connect") {
          // QA rules: V1/V4 free→real id; V1/V4 full→Additional;
          // V3 1-port used→NTD Installation Required; V3 free→real id
          result = getConnectNtdIdOptionsFromResources(supportingResources);
        } else if (supportingResources.length > 0) {
          supportingResources.forEach(resource => {
            const ports = Array.isArray(resource.uniPortD)
              ? resource.uniPortD
              : [];
            if (ports.some(port => port.status === "Used")) {
              if (!result.includes(resource.id)) {
                result.push(resource.id);
              }
            }
          });
        }
      
        if (vm.isOriginal && vm.nbnOrder.ntdId) {
          if (!result.includes(vm.nbnOrder.ntdId)) {
            result.push(vm.nbnOrder.ntdId);
          }
        }
      } else {
        if (
          vm.sqNbnResult.sq != null &&
          vm.sqNbnResult.sq.siteRestriction != null &&
          vm.sqNbnResult.sq.siteRestriction.supportingResource != null &&
          vm.sqNbnResult.sq.siteRestriction.supportingResource.length > 0
        ) {
          vm.sqNbnResult.sq.siteRestriction.supportingResource.forEach(x => {
            let status = vm.nbnOrder.orderType === "Connect" ? "Free" : "Used";
            if (
              x.uniPortD !== undefined &&
              x.uniPortD.map(y => y.status == status).filter(x => x == true)
                .length > 0
            )
              if (!result.includes(x.id)) result.push(x.id);
          });
        }

        if (vm.isOriginal) {
          result.push(vm.nbnOrder.ntdId);
        }
        if (
          !vm.hasFreeNtd &&
          (serviceClass === "3" || serviceClass === "6") &&
          vm.featureFlags.sog5947 &&
          vm.nbnOrder.orderType !== "Transfer"
        ) {
          result.push("Additional NTD Required");
        }
      }

      if (
        vm.nbnOrder.orderType === "Connect" &&
        result.length === 0
      ) {
        result.push("Additional Line Installation");
      }
    
      if (
        vm.nbnOrder.isFibreConnect &&
        result.length === 0
      ) {
        result.push("NTD Installation Required");
      }

      if (
        vm.isOriginal &&
        vm.nbnOrder.ntdId &&
        !result.includes(vm.nbnOrder.ntdId)
      ) {
        result.push(vm.nbnOrder.ntdId);
      }

      // Transfer must use an on-site NTD id — specials cause RJ001000 / RJ001202
      if (vm.nbnOrder.orderType === "Transfer" && !vm.isOriginal) {
        return result.filter(id => isRealNtdId(id));
      }

      return result;
    },

    ntdTypeOptions() {
      let vm = this;

      if(vm.isOriginal){
        const options = [
          "1_PORT",
          "4_PORT",
          "INTERNAL",
          "NTD_2.5",
          "Internal"
        ];
        const current = vm.nbnOrder.ntdType;
        if (current && !options.includes(current)) {
          options.push(current);
        }
        return options;
      } else {
        try {
          const currentNtd = vm.sqNbnResult.sq?.siteRestriction?.supportingResource?.find(
            x => x.id === vm.nbnOrder.ntdId
          );

          let serviceClass = "";
          if (vm.nbnOrder.ntdId !== "") {
            if (
              vm.sqNbnResult.sq != null &&
              vm.sqNbnResult.sq.siteRestriction != null &&
              vm.sqNbnResult.sq.siteRestriction.supportingTechnology != null
            ) {
              serviceClass =
                vm.sqNbnResult.sq.siteRestriction.supportingTechnology
                  .serviceabilityClass;
            }
          }

          return getNtdTypeOptions(
            vm.nbnOrder.ntdId,
            vm.nbnOrder.ntdModifications,
            currentNtd,
            vm.portsOnNtd,
            vm.isOriginal,
            serviceClass,
            vm.nbnOrder.productType,
            vm.featureFlags,
            vm.nbnOrder.isFibreConnect,
            vm.sqNbnResult,
            vm.nbnOrder.orderType
          );
        } catch (e) {
          return [];
        }
      }
    },

    isTransferOrder() {
      return this.nbnOrder.orderType?.toLowerCase() === "transfer";
    },
    transferNtdHint() {
      let vm = this;
      if (!vm.isTransferOrder) return "";
      const version = (vm.ntdVersion || "").toUpperCase().trim();
      if (version === "V1") {
        return "Transfer uses existing V1 NTD on-site. To transfer at higher speeds, submit an NTD replacement order first.";
      }
      return "Transfer uses existing NTD on-site. NTD replacement is not available for transfers.";
    },
    ntdModificationOptions() {
      let vm = this;
      var currentNtd = null;
      try {
        const resources =
          vm.sqNbnResult.sq?.siteRestriction?.supportingResource ?? [];

        const useFirstResource =
          vm.featureFlags?.sog8191 &&
          (SPECIAL_NTD_IDS.includes(vm.nbnOrder.ntdId) || !vm.nbnOrder.ntdId);

        currentNtd = useFirstResource
          ? resources[0]
          : resources.find(x => x.id === vm.nbnOrder.ntdId);

        if (vm.isOriginal && vm.nbnOrder.ntdModifications) {
          return [vm.nbnOrder.ntdModifications];
        }

        const options = getNtdModificationOptions(
          vm.nbnOrder.ntdId,
          currentNtd,
          vm.hasUsedPort,
          vm.checkBandwidthExceeded,
          vm.featureFlags,
          vm.nbnOrder.orderType,
          vm.isFibre,
          vm.nbnOrder.productType,
          vm.nbnOrder.bandwidthProfile,
          vm.speedTiersSupported
        );
        return vm.isOriginal
          ? includeCurrentSelectValue(options, vm.nbnOrder.ntdModifications)
          : options;
      } catch (e) {
        return vm.isOriginal
          ? includeCurrentSelectValue([], vm.nbnOrder.ntdModifications)
          : [];
      }
    },
    // isFieldRequired() {
    //   let vm = this;
    //   console.log(vm.nbnOrder.orderType === "Connect",
    //     (vm.nbnOrder.installationWorkforce !== '' || vm.nbnOrder.installationWorkforce !== undefined),
    //     vm.nbnOrder.installationWorkforce === "NBN Co Install End User")
    //   return (
    //     vm.nbnOrder.orderType === "Connect" &&
    //     (vm.nbnOrder.installationWorkforce !== '' || vm.nbnOrder.installationWorkforce !== undefined) &&
    //     vm.nbnOrder.installationWorkforce === "NBN Co Install End User"
    //   );
    // },
    getSimAddress() {
      let vm = this;
      if (
        (vm.nbnOrder.simAddress && vm.searchSimAddress != "") ||
        vm.isOriginal
      ) {
        return [vm.nbnOrder.simAddress];
      } else {
        vm.nbnOrder.simAddress = null;
        return vm.addressResults;
      }
    },
    getHardwareAddress() {
      let vm = this;
      if (
        (vm.nbnOrder.hardwareAddress && vm.searchHardwareAddress != "") ||
        vm.isOriginal
      ) {
        return [vm.nbnOrder.hardwareAddress];
      } else {
        vm.nbnOrder.hardwareAddress = null;
        return vm.addressResults;
      }
    },
    businessOptionEnabled() {
      let vm = this;
      return vm.filteredParties.length > 0;
    },
    hardwareLabel() {
      let vm = this;
      if (vm.isOriginal && vm.isHistoricalOrder) return "Hardware Options";
      else return "Modem Required";
    },
    hasExistingRadius() {
      let vm = this;
      let val =
        vm.nbnOrder.existingRadiusUsername !== undefined &&
        vm.nbnOrder.existingRadiusUsername !== null &&
        vm.nbnOrder.existingRadiusUsername !== "";
      vm.vispRequired = !val;
      if (val) vm.searchRadiusUsernames(vm.nbnOrder.existingRadiusUsername);
      return val;
    },
    hasNewRadius() {
      let vm = this;
      let val =
        vm.nbnOrder.radiusUsername !== undefined &&
        vm.nbnOrder.radiusUsername !== null &&
        vm.nbnOrder.radiusUsername !== "";
      vm.vispRequired = val;
      return val;
    },
    showNewRadiusFields() {
      let vm = this;
      return vm.isOriginal
        ? vm.isLayer3 && vm.hasNewRadius
        : vm.isLayer3 && vm.vispRequired;
    },
    showExistingRadiusFields() {
      let vm = this;
      return vm.isOriginal
        ? vm.isLayer3 && vm.hasExistingRadius
        : vm.isLayer3 && !vm.vispRequired;
    },
    enableUsernameError() {
      let vm = this;
      return (
        vm.showNewRadiusFields &&
        (vm.nbnOrder.radiusUsername === "" ||
          vm.nbnOrder.radiusUsername === null)
      );
    },
    enablePasswordError() {
      let vm = this;
      return (
        vm.showNewRadiusFields &&
        (vm.nbnOrder.radiusPassword === "" ||
          vm.nbnOrder.radiusPassword === null)
      );
    },
    showCheckbox() {
      let vm = this;
      return (
        vm.featureFlags.sog5619 &&
        (vm.isOriginal ? vm.nbnOrder.isFibreConnect : vm.showFibreCheckbox)
      );
    },
    showAppointmentNote() {

      let vm = this;
      const isMandatory = vm.featureFlags.sog6522 ? vm.isAppointmentMandatoryNew : vm.isAppointmentMandatory;
      const bandwidthInfo = vm.checkBandwidthExceeded;
      const hasExceededBandwidth = bandwidthInfo?.hasExceeded;

      if (vm.nbnOrder.productType === 'Fixed Wireless' && vm.shouldDisplayFWAppointment) {
        return true;
      }

      if (!isMandatory) {
        return false;
      }
      if (vm.isOriginal) {
        return false;
      }
      if (vm.hasFreeNtd) {
        return false;
      }
      if (vm.isPendingServiceability) {
        return false;
      }

      if (!vm.nbnOrder.isFibreConnect || vm.nbnOrder.isFibreConnect === undefined) {
        return false;
      }

      if (!hasExceededBandwidth) {
        return false;
      }
      return true;
    },
    showIPoEFeature() {
      let vm = this;
      return (
        (vm.featureFlags.sog5822 && !vm.nbnOrder.isIpoe) ||
        !vm.featureFlags.sog5822
      );
    },
    requireProductTemplate() {
      let vm = this;
      return vm.featureFlags.sog5773;
    },
    requireVlanTag() {
      let vm = this;
      return (
        vm.featureFlags.sog5773 &&
        vm.nbnOrder.productTemplate !== null &&
        vm.nbnOrder.productTemplate !== "" &&
        vm.nbnOrder.productTemplate.includes("tag")
      );
    },
    productTemplates() {
      let vm = this;
      const templates = getProductTemplates(
        vm.nbnOrder.productType,
        vm.featureFlags,
        vm.isOriginal
      );
      const current = vm.nbnOrder.productTemplate;
      if (current && !templates.some((t) => t.value === current)) {
        return [
          ...templates,
          { text: current, value: current, disabled: false },
        ];
      }
      return templates;
    },
    checkTechnologyRules() {
      let vm = this;
      let result = false;

      if (vm.isFttp) {
        result =
          vm.ServiceClass === "0" ||
          vm.ServiceClass === "1" ||
          vm.ServiceClass === "3";
        if (result) vm.checkType = "Earliest";
      }

      return result;
    },
    workforceOptions() {
      let vm = this;
      let options = [
        {
          text: "Pro install",
          value: "NBN Co Install",
          disabled: false
        },
        {
          text: "NCD already on-site",
          value: "RSP Install End User",
          disabled: false
        },
        {
          text: "Self-Installation Kit (SIK)",
          value: "NBN Co Install End User",
          disabled: false
        }
      ]

      if (
        vm.nbnOrder.serviceClass === "24" &&
        vm.nbnOrder.ntdId !== null &&
        vm.nbnOrder.ntdId !== "" &&
        vm.isNoChange
      ) {
        if (vm.sqNbnResult.sq.siteRestriction.supportingResource.length > 0) {
          vm.sqNbnResult.sq.siteRestriction.supportingResource.forEach(x => {
            if (x.id === vm.nbnOrder.ntdId) {
              if (x.uniPortD[0].status === "Free") {
                options.forEach(x => {
                  if (x.value === "NBN Co Install")
                    x.text = "NTD already on-site";
                });
              }
            }
          });
        }
      }
      return options;
    },

    checkBandwidthExceeded() {
      let vm = this;
      let bandwidth = [];
      if (vm.isOriginal) {
        bandwidth = NFASBandwidthProfile;
      } else {
        bandwidth = NFASBandwidthProfile.filter(
          option =>
            option.value !== "D25-50_U5-20_Mbps_TC4_P" &&
            option.value !== "D25-100_U5-40_Mbps_TC4_P"
        );
      }
      const exceeded = vm.checkBandwidth(bandwidth) || [];
      return { exceeded: exceeded, original: bandwidth, hasExceeded: exceeded.length > 0 };
    },
    hasTechnicalContact(){
      let vm = this;
      return vm.nbnOrder.installationWorkforce && vm.nbnOrder.installationWorkforce === "NBN Co Install End User"
    },
    showNtdWarning() {
      let vm = this;
      return vm.nbnOrder.ntdModifications === 'REQUEST NEW NTD' && !vm.isOriginal;
    },
    showNtdModifications() {
      const vm = this;
        
      const isEligibleOrder =
        ((!vm.isDisconnect && !vm.isNCAS) || vm.nbnOrder.isFibreConnect);

      if (vm.isOriginal && vm.nbnOrder.ntdModifications && isEligibleOrder) {
        return true;
      }
        
      const baseInvalidNtdIds = [
        ...(vm.featureFlags?.sog8191 ? [] : ["NTD Installation Required"]),
        "Additional Line Installation"
      ];
        
      const extraInvalidNtdIds = vm.featureFlags?.sog8713
        ? []
        : ['Additional NTD Required'];
        
      const invalidNtdIds = [...baseInvalidNtdIds, ...extraInvalidNtdIds];
        
      return isEligibleOrder && !invalidNtdIds.includes(vm.nbnOrder.ntdId);
    },
    showReplaceNTD(){
      let vm = this;

      const baseCondition =
        vm.isConnect &&
        vm.isHfc &&
        vm.getNtdServiceClass === '24' &&
        vm.nbnOrder.ntdId !== 'Additional Line Installation';

      return vm.featureFlags?.sog8713
        ? baseCondition && !vm.showNtdModifications
        : baseCondition;
    }
  },
  watch: {
    "nbnOrder.productType": function() {
      let vm = this;
      vm.updateOnSiteLabel();
      if (!vm.isOriginal) {
        vm.nbnOrder.productTemplate = resolveProductTemplateForType(
          vm.nbnOrder.productType,
          vm.nbnOrder.productTemplate,
          vm.featureFlags
        );
      }
    },
    "nbnOrder.orderType": function(new_value) {
      let vm = this;
      if (new_value.toLowerCase() == "transfer") {
        vm.nbnOrder.connectionDateRequire = "No";
        vm.nbnOrder.scheduledDateTime = "";
      }
      if (vm.isNCAS) {
        // vm.nbnOrder.cpiId = vm.cpiOptions.length > 0 ? vm.cpiOptions[0] : "";
        vm.setCpiId(vm.sqNbnResult);
      }

      if(vm.featureFlags?.sog8191 && vm.isFibre && !vm.isOriginal){
        vm.setNtdId(vm.sqNbnResult);
        if (vm.ntdModificationOptions.length > 0) {
          vm.setNtdModificationWithContext({
            ntdModifications:
              new_value.toLowerCase() === "transfer"
                ? NTD_MODIFICATION_OPTIONS.USE_SELECTED
                : vm.ntdModificationOptions[0],
            contractTerm: vm.nbnOrder.contractTerm,
            bandwidthProfile: vm.nbnOrder.bandwidthProfile
          });
        }
      }

      if (
        (vm.nbnOrder.ntdId == null ||
          vm.nbnOrder.ntdId == "" ||
          (new_value.toLowerCase() === "transfer" &&
            isSpecialNtdId(vm.nbnOrder.ntdId))) &&
        !vm.isNCAS
      ) {
        const firstReal = (vm.ntdOptions || []).find(id => isRealNtdId(id));
        vm.nbnOrder.ntdId =
          firstReal ||
          (vm.ntdOptions.length > 0 ? vm.ntdOptions[0] : "");
        if (isRealNtdId(vm.nbnOrder.ntdId)) {
          vm.nbnOrder.existingNtdId = vm.nbnOrder.ntdId;
        }
      }

      vm.setInstallationWorkforceOptionsNew();
    },
    showNewNbnOrder: function() {
      let vm = this;
      if (!vm.showNewNbnOrder) vm.isFieldRequired = false;
    },
    searchSimAddress: function(val) {
      let vm = this;
      if (val !== null && !vm.isOriginal) {
        if (val.length > 4) vm.searchAddress(val);
      }
    },
    searchHardwareAddress: function(val) {
      let vm = this;
      if (val !== null && !vm.isOriginal) {
        if (val.length > 4) vm.searchAddress(val);
      }
    },
    "nbnOrder.cpiId": function() {
      let vm = this;

      if (vm.nbnOrder.cpiId !== "") {
        vm.setInstallationWorkforceOptionsNew();
      }
    },
    "nbnOrder.ntdId": function(newId) {
      let vm = this;
      if (isRealNtdId(newId)) {
        vm.setExistingNtdId(newId);
      } else if (isSpecialNtdId(newId) && !vm.nbnOrder.existingNtdId) {
        const resources =
          vm.sqNbnResult?.sq?.siteRestriction?.supportingResource || [];
        const firstReal = resources.find(r => isRealNtdId(r?.id));
        if (firstReal) {
          vm.setExistingNtdId(firstReal.id);
        }
      }

      // Transfer cannot submit ADD / placeholder NTD values
      if (
        vm.nbnOrder.orderType === "Transfer" &&
        isSpecialNtdId(vm.nbnOrder.ntdId)
      ) {
        const realOption = (vm.ntdOptions || []).find(id => isRealNtdId(id));
        if (realOption) {
          vm.nbnOrder.ntdId = realOption;
          vm.setExistingNtdId(realOption);
        }
        vm.setNtdModificationWithContext({
          ntdModifications: NTD_MODIFICATION_OPTIONS.USE_SELECTED,
          contractTerm: vm.nbnOrder.contractTerm,
          bandwidthProfile: vm.nbnOrder.bandwidthProfile
        });
      }
      if (vm.nbnOrder.ntdId !== "") {
        if (
          vm.sqNbnResult.sq != null &&
          vm.sqNbnResult.sq.siteRestriction != null &&
          vm.sqNbnResult.sq.siteRestriction.supportingTechnology != null
        ) {
          var sc =
            vm.sqNbnResult.sq.siteRestriction.supportingTechnology
              .serviceabilityClass;
          // if (
          //   sc === "24" &&
          //   vm.nbnOrder.ntdId !== "Additional Line Installation" &&
          //   vm.nbnOrder.orderType === "Connect"
          // ) {
          //   vm.nbnOrder.replaceNtd = true;
          // } else {
          //   vm.nbnOrder.replaceNtd = false;
          // }
          if (sc === "21" || sc === "22") {
            vm.installationWorkforces = [
              { text: "Pro install", value: "NBN Co Install", disabled: false }
            ];
          } else if (sc === "24") {
            if (
              vm.nbnOrder.ntdId !== "Additional Line Installation" &&
              (vm.nbnOrder.replaceNtd !== undefined || !vm.nbnOrder.replaceNtd)
            ) {
              vm.installationWorkforces = [
                {
                  text: "NCD already on-site",
                  value: "NBN Co Install",
                  disabled: false
                }
              ];

              if (vm.featureFlags.sog5947) vm.updateOnSiteLabel();
            } else {
              vm.installationWorkforces = [
                {
                  text: "Pro install",
                  value: "NBN Co Install",
                  disabled: false
                },
                {
                  text: "Self-Installation Kit (SIK)",
                  value: "NBN Co Install End User",
                  disabled: false
                }
              ];
            }
          } else {
            vm.installationWorkforces = [
              { text: "Pro install", value: "NBN Co Install", disabled: false },
              {
                text: "NCD already on-site",
                value: "RSP Install End User",
                disabled: false
              },
              {
                text: "Self-Installation Kit (SIK)",
                value: "NBN Co Install End User",
                disabled: false
              }
            ];
          }
        }
      }
      vm.applyForcedFwNtdFields();
    },
    "nbnOrder.replaceNtd": function() {
      let vm = this;
      if (vm.nbnOrder.replaceNtd === true) {
        if (
          vm.sqNbnResult.sq != null &&
          vm.sqNbnResult.sq.siteRestriction != null &&
          vm.sqNbnResult.sq.siteRestriction.supportingTechnology != null
        ) {
          var scValue =
            vm.sqNbnResult.sq.siteRestriction.supportingTechnology
              .serviceabilityClass;
          if (scValue === "24") {
            vm.installationWorkforces = [
              { text: "Pro install", value: "NBN Co Install", disabled: false },
              {
                text: "Self-Installation Kit (SIK)",
                value: "NBN Co Install End User",
                disabled: false
              }
            ];
          } else {
            vm.installationWorkforces = [
              { text: "Pro install", value: "NBN Co Install", disabled: false },
              {
                text: "NCD already on-site",
                value: "RSP Install End User",
                disabled: false
              },
              {
                text: "Self-Installation Kit (SIK)",
                value: "NBN Co Install End User",
                disabled: false
              }
            ];
          }
        }
      } else {
        if (
          vm.sqNbnResult.sq != null &&
          vm.sqNbnResult.sq.siteRestriction != null &&
          vm.sqNbnResult.sq.siteRestriction.supportingTechnology != null
        ) {
          var scValue2 =
            vm.sqNbnResult.sq.siteRestriction.supportingTechnology
              .serviceabilityClass;
          if (scValue2 === "24") {
            vm.installationWorkforces = [
              {
                text: "NCD already on-site",
                value: "NBN Co Install",
                disabled: false
              }
            ];

            if (vm.featureFlags.sog5947) vm.updateOnSiteLabel();
          } else {
            vm.installationWorkforces = [
              { text: "Pro install", value: "NBN Co Install", disabled: false }
            ];
          }
        }
      }
    },
    searchRadius: function(val) {
      let vm = this;
      if (val !== null && !vm.isOriginal) {
        if (val.length >= 3) {
          vm.searchRadiusUsernames(val);
        }
      }
    },
    vispRequired: function(val) {
      let vm = this;
      if (val) vm.resetExistingRadiusDetails();
      else vm.resetNewRadiusDetails();
    },
    "nbnOrder.isFibreConnect": function() {
      let vm = this;
      if (vm.nbnOrder.isFibreConnect) {
        vm.setProductType("Fibre");
        if (vm.featureFlags?.sog8191 && vm.isFibre) {
          vm.setNtdId(vm.sqNbnResult);
        }
      } else {
        var technology = vm.sqNbnResult.sq
          ? vm.sqNbnResult.sq.siteRestriction.supportingTechnology
              .primaryAccessTechnology
          : "";
        vm.setProductType(technology);
        vm.resetNbnOrderType();
      }
    },
    "nbnOrder.isConnectOutstanding": function() {
      let vm = this;
      vm.connectOutstanding = vm.nbnOrder.isConnectOutstanding;
    },
    isOriginal: function(val){
      let vm = this;
      if(val){
        vm.$refs.technicalDetailsRef.setTechnicalDetails();
      }
    },
    resolvedFwNtdModification: {
      immediate: true,
      handler(value) {
        let vm = this;

        if (vm.isOriginal || !vm.isFixedWireless || !value) {
          if (vm.isFixedWireless) vm.shouldDisplayFWAppointment = false;
          return;
        }
        if (vm.isPendingServiceability) {
          vm.shouldDisplayFWAppointment = false;
          return;
        }

        vm.applyForcedFwNtdFields();
      }
    },
    shouldAutoReplaceSelectedNtd: {
      immediate: true,
      handler(shouldAuto) {
        let vm = this;

        if (vm.isFixedWireless) {
          vm.shouldDisplayFWAppointment = shouldAuto && !vm.isOriginal && !vm.isPendingServiceability;
          return;
        }

        const REPLACE_SELECTED_NTD = "REPLACE SELECTED NTD";

        if (vm.isOriginal) {
          vm.shouldDisplayFWAppointment = false;
          return;
        }
        if (vm.isPendingServiceability) {
          vm.shouldDisplayFWAppointment = false;
          return;
        }

        // Set appointment flag based on whether auto-replace conditions are met
        vm.shouldDisplayFWAppointment = shouldAuto;

        // Already set to REPLACE SELECTED NTD — nothing to do
        if (vm.nbnOrder.ntdModifications === REPLACE_SELECTED_NTD) return;

        // Only auto-set when bandwidth exceeds supported tiers
        if (!shouldAuto) return;

        const options = vm.ntdModificationOptions || [];
        const exists = options.some(
          opt => (typeof opt === "string" ? opt : opt.value) === REPLACE_SELECTED_NTD
        );

        if (exists) {
          vm.autoReplacingNtd = true;
          vm.setNtdModificationWithContext({
            ntdModifications: REPLACE_SELECTED_NTD,
            contractTerm: vm.nbnOrder.contractTerm,
            bandwidthProfile: vm.nbnOrder.bandwidthProfile
          });
          vm.triggerNtdTypeUpdate();
          vm.$nextTick(() => {
            vm.autoReplacingNtd = false;
          });
          vm.$emit("emitNbnOrderItem", vm.nbnOrder, { skipReset: true });
        }
      }
    },
    "nbnOrder.bandwidthProfile": function () {
      const vm = this;

      if (vm.isFixedWireless) {
        vm.applyForcedFwNtdFields();
        return;
      }
        
      if (!(vm.featureFlags.sog8562 && vm.isFibre)) return;
        
      const resources =
        vm.sqNbnResult?.sq?.siteRestriction?.supportingResource ?? [];
        
      const selectedNtdObj =
        resources.find(x => x?.id === vm.nbnOrder?.ntdId) || resources[0];
        
      const selectedBandwidth = vm.nbnOrder.bandwidthProfile;
        
      // ===== Bandwidth + capacity =====
      const bandwidthData = selectedNtdObj?.NTDBandwidth ?? [];
        
      const remainingCapacity =
        bandwidthData.find(
          item => item.bandwidthType === "RemainingBandwidthDownstream"
        )?.bandwidth ?? 0;
        
      const selectedBandwidthText =
        BANDWIDTH_PROFILES.NFAS.find(x => x.value === selectedBandwidth)?.text || "";
        
      const selectedDownloadSpeed =
        parseInt(selectedBandwidthText.split("/")[0], 10) || 0;
        
      // ===== Current NTD =====
      const currentNtd = resources.find(x => x.id === vm.nbnOrder.ntdId);
        
      const hasNtdFreePort =
        currentNtd?.uniPortD?.some(port => port.status === "Free") ?? false;
        
      // ===== Determine NTD Modification =====
      let ntdModificationValue = "";
        
      const exceedsCapacity = selectedDownloadSpeed > remainingCapacity;
      const isNonTransferOrder =
        vm.nbnOrder.orderType?.toLowerCase() !== "transfer";
      const shouldCheckTransferRule = vm.featureFlags?.sog8737;
        
      const isNtdInstallationRequired =
        vm.nbnOrder.ntdId === "NTD Installation Required";
        
      const isAdditionalNtdRequired =
        vm.nbnOrder.ntdId === "Additional NTD Required" ||
        vm.nbnOrder.ntdId === "Additional Line Installation";

      const onSiteNtdId = resolveOnSiteNtdId(
        vm.nbnOrder.ntdId,
        vm.nbnOrder.existingNtdId,
        resources
      );
        
      if (vm.nbnOrder.orderType?.toLowerCase() === "transfer") {
        ntdModificationValue = "USE SELECTED NTD";
      } else if (isNtdInstallationRequired) {
        // Replace only when an on-site NTD exists (V3 used-port).
        // Greenfield SC 1/2/5 has no NTD to replace — request a new one.
        ntdModificationValue = onSiteNtdId
          ? "REPLACE SELECTED NTD"
          : "REQUEST NEW NTD";
      } else if (isAdditionalNtdRequired) {
        // V1/V4 all ports used => REQUEST NEW NTD
        ntdModificationValue = "REQUEST NEW NTD";
      } else if (!hasNtdFreePort) {
        if (
          vm.featureFlags?.sog8191 &&
          vm.nbnOrder.orderType === "Transfer"
        ) {
          ntdModificationValue = "USE SELECTED NTD";
        } else {
          ntdModificationValue = "REQUEST NEW NTD";
        }
      } else if (
        exceedsCapacity &&
        (!shouldCheckTransferRule || isNonTransferOrder)
      ) {
        ntdModificationValue = "REPLACE SELECTED NTD";
      } else {
        const isSameNtd =
          selectedNtdObj && selectedNtdObj.id === vm.nbnOrder.ntdId;
      
        if (isSameNtd) {
          ntdModificationValue = "USE SELECTED NTD";
        }
      }
    
      if (!vm.featureFlags?.sog8191 || vm.nbnOrder.bandwidthProfile) {
        vm.setNtdModificationWithContext({
          ntdModifications: ntdModificationValue,
          contractTerm: vm.nbnOrder.contractTerm,
          bandwidthProfile: vm.nbnOrder.bandwidthProfile
        });
      }
    
      vm.triggerNtdTypeUpdate();
    },
    isFixedWireless: {
      immediate: false,
      handler(isNowFixedWireless) {
        let vm = this;

        if (vm.isOriginal) return;

        if (isNowFixedWireless) {
          vm.nbnOrder.nbnAssureRequired = "No";
          vm.nbnOrder.simRequired = "No";
          vm.nbnOrder.nbnAssureOption = null;
          vm.nbnOrder.simAddress = null;
          vm.nbnOrder.usim = null;
        }
      }
    }
  }
};
</script>

<style scoped>
::v-deep .v-select__selection,
.v-select__selection--comma,
.v-select.v-text-field input {
  color: black !important;
}
.hidden-column {
  display: none;
}
.error-message {
  color: red;
  font-size: 12px;
  padding-left: 10px;
}
.red-hint-radio >>> .v-messages__message {
  color: red !important;
}
</style>
